<template>
  <div class="main">
    <div class="package" v-if="packageList && this.bookedPatient.bookedType!=2">
      <van-tree-select height="100%" :items="packageTypes" :main-active-index.sync="activePackagetype"
                       @click-nav="navClick">
        <template #content>
          <van-field name="checkbox" v-for="(item,index) in packageList" v-bind:key="'packageList' +index">
            <template #input>
              <div class="package-item" @click="showDetail(item.packageId)">
                <div style="width:50px;height: 100%;padding:5px 10px;display: flex;">
                  <img :src='item | picFilter' style="width: 50px;height: 50px;border-radius: 1rem;">
                </div>
                <div style="height: 100%;display: flex;flex-flow: column;justify-content: space-around;flex: 1">
                  <span style="font-weight: 700;font-size: 2.5rem;color:#171A32;margin-bottom: 3px">
                    {{ item.packageName }}
                  </span>

                  <span style="font-size: 2.2rem;color: #898989;
                                  word-break: break-all;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                  display: -webkit-box;
                                  text-overflow: ellipsis;
                                  line-height: 1.2em;
                                  -webkit-box-orient: vertical;
                                  -webkit-line-clamp: 2;">
                    {{ item.description }}
                    </span>


                  <!--套餐+项目和套餐允许退项结算方式显示套餐实际金额，其他显示原价金额-->
                  <p style="font-size:2rem;color: #F56C6C;">
                    <span v-if="singleShowMoney && showMoney && (settlementMode != '2' && settlementMode != '5')">
                      <em style="font-size: 1.8rem;color: #999">￥</em><strong>{{ item.price }}</strong>
                    </span>
                    <span v-if="singleShowMoney && showMoney && (settlementMode == '2' || settlementMode == '5')">
                      <em style="font-size: 1.8rem;color: #999">￥</em><strong>{{ item.actualPrice }}</strong>
                    </span>
                  </p>
                  <div style="width: 100%;display: flex;justify-content:flex-start;align-items: center;">
                    <van-tag plain color="#b9b7b7" text-color="#b9b7b7" v-if="item.sexId == '1'">男性</van-tag>
                    <van-tag plain color="#b9b7b7" text-color="#b9b7b7" v-if="item.sexId == '2'">女性</van-tag>
                    <van-tag plain color="#b9b7b7" text-color="#b9b7b7" v-if="item.sexId == '0'">通用</van-tag>
                  </div>
                </div>
              </div>
              <van-button style="width: 15%;display: flex;justify-content: center;color: #9DA3A7;border: none"
                          @click="checkPackage(item,$event)" :disabled="item.isSelected">
                <span>
                  <van-icon name="add" size="4rem" v-if="!item.isSelected"/>
                  <van-icon name="checked" size="4rem" color="#c8c9cc" v-if="item.isSelected"/>
                </span>
              </van-button>
            </template>
          </van-field>
          <van-empty v-if="packageList.length == 0 && showAdd == false" description="当前分组套餐未设置"/>
          <!--自选项目模块-->
          <div v-if="showAdd">
            <div
                style="width: 100%;height: 89%;padding-bottom: 12rem;display: flex;flex-flow: row;justify-content: space-around;">
              <div style="width: 30%;height:calc(100vh - 19rem);overflow-y: scroll;" class="plur-item-side">
                <van-cell-group v-for="(item,index) in datasByDept" v-bind:key="'deptArr' + index" :border="false"
                                v-bind:class="{ active: item.departmentName == checkDeptStr}">
                  <div class="corner top-corner"></div>
                  <!-- 科室名称 -->
                  <van-cell :title="item.departmentName" @click="checkDept(index,item.departmentName)"/>
                  <div class="corner bottom-corner"></div>
                </van-cell-group>
              </div>
              <!-- 选中科室后显示的列 -->
              <div style="width: 68%;height:calc(100vh - 19rem);overflow-y: scroll;background: #fff;
        display: flex;flex-flow: column;overflow-x: hidden" class="plur-item-main" @scroll="handleScroll">
                <div class="grouplist" v-for="(item,index) in datasByDept" v-bind:key="'datasByDept' + index"
                     :ref="setItemRef(index)">
                  <div class="grouplist-title" v-if="unitOrderShow ? item.departmentName == checkDeptStr : true ">
                    {{ item.departmentName }}
                  </div>
                  <van-checkbox-group v-model="result">
                    <van-cell-group>
                      <div v-for="(value,index) in (unitOrderShow ? item.items : item.groupMains)"
                           v-bind:key="'groups' + index">
                        <van-cell
                            :name="value.groupId"
                            :title="value.groupName"
                            :label="value.clinicalSignIficance"
                            :style="{color:disableGroup.includes(value.groupId) || disabledExclude.includes(value.groupId)?'#c8c9cc':'initial'}"
                            style="font-weight: 700"
                            v-if="sexFilter ? !(disableGroup.includes(value.groupId) || disabledExclude.includes(value.groupId)) : true"
                        >
                          <template #right-icon>
                            <van-checkbox
                                v-if="!estimateRelevanceGroupItem(value)"
                                icon-size="18px"
                                @click="checkGroup(value)"
                                :name="value.groupId"
                                :disabled=" disableGroup.includes(value.groupId) || disabledExclude.includes(value.groupId) "
                                style="margin-right: 1rem;">
                            </van-checkbox>
                          </template>
                        </van-cell>
                      </div>
                    </van-cell-group>
                  </van-checkbox-group>
                </div>

              </div>
            </div>
            <van-goods-action style="bottom: 7rem;left: 20%;background-color: transparent;">
              <van-goods-action-button type="warning" style="height:2em" text="清空已选自选" @click="clearGroups"
                                       color="linear-gradient(to right, #ff976a, #F56C6C)"/>
              <van-goods-action-button type="warning" style="height:2em" text="已选自选项目"
                                       @click="showChooseGroup = true"
                                       color="linear-gradient(to right, #BE99FF, #7232DD)"/>
            </van-goods-action>
          </div>
        </template>
      </van-tree-select>

      <transition
          @before-enter="beforeEnter"
          @enter="enter"
          @after-enter="afterEnter"
      >
        <div class="ball" v-show="ball.show">
          <div class="innerBall">
            <van-image
                width="4rem"
                height="4rem"
                :src="ball.imgSrc"
            />
          </div>
        </div>
      </transition>

    </div>
    <div v-if="packageList.length == 0 && showAdd == false">
      <van-empty image="search" description="没有查询到套餐"/>
    </div>
    <div class="footer">
      <van-goods-action>
        <div style="margin: 0 1rem">
          <van-badge :content="checkedPackages.length">
            <van-button round size="small" color="linear-gradient(to right, #90a1c5, #576b95)"
                        @click="showCheckedPackages=true">
              <van-icon :name="checkedPackages.length == 0?'shopping-cart-o':'shopping-cart'" size="3rem"></van-icon>
              已选套餐
            </van-button>
          </van-badge>
        </div>
        <div v-if="singleShowMoney && !VUE_APP_HIDE_ORDERMONEY" style="width:45%">
          <van-button round block size="small" color="linear-gradient(to right, #969799, #646566)"
                      style="white-space: nowrap">
            实收 <span style="font-weight: 700">{{ actualAmount }}</span> 个人 <span
              style="font-weight: 700">{{ selfAmount }}</span></van-button>
        </div>
        <!--        <van-goods-action-button v-if="bookedPatient.bookedType!=2 && bookedPatient.isReplaceItem!='0'" type="warning" text="加项"  color="linear-gradient(to right, #10E3E9, #409EFF)" @click="plusItem" icon="plus"/>-->
        <van-goods-action-button type="danger" text="下一步" @click="showChecked"
                                 color="linear-gradient(to right, #E6A23C, #F56C6C)"/>
      </van-goods-action>
    </div>
    <!--已选套餐浮窗-->
    <van-popup v-model="showCheckedPackages" round position="bottom" close-icon-position="top-left"
               :style="{ width: '100%',height:'60%'}">
      <van-field name="checkbox" v-for="(item,index) in checkedPackages" v-bind:key="'checkedPackages' + index">
        <template #input>
          <div class="package-item" @click="showDetail(item.packageId)">
            <div style="width:50px;height: 100%;padding:5px 10px;display: flex;">
              <img :src='item | picFilter' style="width: 50px;height: 50px;border-radius: 1rem;">
            </div>
            <div style="height: 100%;display: flex;flex-flow: column;justify-content: space-around;flex: 1">
                  <span style="font-weight: 700;font-size: 2.5rem;color:#171A32;">
                    {{ item.packageName }}
                  </span>
              <!--套餐+项目和套餐允许退项结算方式显示套餐实际金额，其他显示原价金额-->
              <p style="font-size:2rem;color: #F56C6C;">
                <span v-if="singleShowMoney && showMoney && (settlementMode != '2' && settlementMode != '5')">
                  <em style="font-size: 1.8rem;color: #999">￥</em><strong>{{ item.price }}</strong>
                </span>
                <span v-if="singleShowMoney && showMoney && (settlementMode == '2' || settlementMode == '5')">
                  <em style="font-size: 1.8rem;color: #999">￥</em><strong>{{ item.actualPrice }}</strong>
                </span>
              </p>


              <div style="width: 100%;display: flex;justify-content:flex-start;align-items: center;">
                <van-tag plain color="#b9b7b7" text-color="#b9b7b7" v-if="item.sexId == '1'">男性</van-tag>
                <van-tag plain color="#b9b7b7" text-color="#b9b7b7" v-if="item.sexId == '2'">女性</van-tag>
                <van-tag plain color="#b9b7b7" text-color="#b9b7b7" v-if="item.sexId == '0'">通用</van-tag>

              </div>
            </div>
          </div>
          <van-button
              style="width: 15%;display: flex;justify-content: center;color: #9DA3A7;background:none;border: none;"
              @click="clearPackage(item)" :disabled="item.modify == '0'?true:false">
            <span><van-icon name="clear" size="4rem" color="#ff6c6c"/></span>
          </van-button>
        </template>
      </van-field>
      <van-empty v-if="checkedPackages.length == 0" description="没有已选套餐"/>
    </van-popup>
    <!--已选自选项目浮窗-->
    <van-popup v-model="showChooseGroup" round position="bottom" close-icon-position="top-left"
               :style="{ width: '100%',height:'60%'}">
      <van-cell v-for="(item,index)  in chooseGroup" v-bind:key="'chooseGroup' + index">
        <template #title>
          <span class="custom-title">{{ (index + 1) + '、' + item.groupName }}</span>
        </template>
        <template #right-icon>
                  <span style="line-height: 4rem" v-if="!item.relevanceGroupItem">
                    <van-icon name="clear" size="3rem" color="rgb(255, 108, 108)" style="margin-top: 1rem"
                              @click="delGroup(item)"></van-icon>
                  </span>
        </template>
      </van-cell>
      <van-empty v-if="chooseGroup.length == 0" description="没有加做项目"/>
    </van-popup>

    <van-popup close-icon="close" :closeable="bookedPatient.bookedType != '2'" v-model="showChose" position="bottom"
               :style="{ height: '100%' }">
      <div style="width: 100%;height: 100%;display: flex">
        <van-goods-action style="z-index: 9999">
          <van-goods-action-button type="danger" text="上一步" @click="showChose = false"
                                   color="linear-gradient(to right, #E6A23C, #F56C6C)"
                                   v-if="bookedPatient.bookedType != '2'"/>
          <van-goods-action-button type="danger" text="提交预约" @click="orderNow"
                                   color="linear-gradient(to right, #10E3E9, #409EFF)" :disabled="isSubmitting"
                                   :loading="isSubmitting" loading-text="提交中..."/>
        </van-goods-action>
        <div style="width: 100%;">
          <div v-if="bookedPatient.bookedType != '2'"
               style="width: 100%;height: 15rem;display: flex;flex-flow: row;margin-top: 7rem;
            display: flex;flex-flow: row;justify-content: space-around;">

            <div
                style="width: 100%;height: 100%;display: flex;flex-flow: column;font-size: 2.8rem;justify-content: center;">
              <span style="margin-left: 2rem;font-size: 2.2rem;margin-top: 1rem;color: #666666;">
                体检时间：<span style="font-size: 2.5rem;margin-top: 1.5rem;color: gray;margin-right: 1rem;">{{
                  checkDate == undefined ? '未选' : checkDate
                }}</span>

              </span>
              <span v-if="singleShowMoney && !VUE_APP_HIDE_ORDERMONEY"
                    style="margin-left: 2rem;font-size: 2.2rem;margin-top: 1rem;color: #666666;">
<!--                应收金额<span-->
                <!--                  style="font-size: 2.5rem;margin-top: 1.5rem;color: #EF5425;margin-right: 1rem;">￥{{-->
                <!--                  amount-->
                <!--                }}</span>-->
                实收金额：
                <span
                    style="font-size: 2.5rem;margin-top: 1.5rem;color: #EF5425;margin-right: 1rem;">￥{{
                    actualAmount || 0
                  }}</span>
                结算方式：<span style="font-size: 2.5rem;margin-top: 1.5rem;color: #EF5425;">{{
                  bookedPatient.settlementMode | settlementModeFilter
                }}</span>
                <!--                折扣-->
                <!--                <span-->
                <!--                  style="font-size: 2.5rem;margin-top: 1.5rem;color: #EF5425;margin-right: 1rem;">{{-->
                <!--                  discount-->
                <!--                }}</span>-->
              </span>
              <!--              <span style="margin-left: 2rem;font-size: 2.2rem;margin-top: 1rem;color: #666666;">-->
              <!--                套餐金额<span-->
              <!--                  style="font-size: 2.5rem;margin-top: 1.5rem;color:gray;margin-right: 1rem;">￥{{-->
              <!--                  packageamount-->
              <!--                }}</span>-->
              <!--                加项金额<span-->
              <!--                  style="font-size: 2.5rem;margin-top: 1.5rem;color: gray;margin-right: 1rem;">￥{{-->
              <!--                  groupPrice || 0-->
              <!--                }}</span>-->
              <!--                合计<span-->
              <!--                  style="font-size: 2.5rem;margin-top: 1.5rem;color: gray;margin-right: 1rem;">￥{{-->
              <!--                  (parseFloat(packageamount) + parseFloat(groupPrice)).toFixed(2)-->
              <!--                }}</span>-->
              <!--              </span>-->
              <span v-if="singleShowMoney && !VUE_APP_HIDE_ORDERMONEY"
                    style="margin-left: 2rem;font-size: 2.2rem;margin-top: 1rem;color: #666666;">
                <span style="font-size: 2.2rem;margin-top: 1rem;color: #666666;">单位支付：
                  <span style="font-size: 2.5rem;margin-top: 1.5rem;color: #EF5425;">{{
                      '￥' + bookedPatient.unitQuota
                    }}</span></span>
                <span style="margin-left: 2rem;font-size: 2.2rem;margin-top: 1rem;color: #666666;">个人支付：
                  <span style="font-size: 2.5rem;margin-top: 1.5rem;color: #EF5425;">{{
                      '￥' + selfAmount
                    }}</span></span>
              </span>

            </div>
          </div>
          <dl class="order-dates" style="height: 21rem">
            <dt><h3>可约体检日期</h3>
              <div class="dt-right" @click="showDate = true">全部日期
                <van-icon name="arrow"/>
              </div>
            </dt>
            <dd>
              <ul>
                <li v-for="(item,index) in orderWeektime" v-bind:key="'orderWeektime' + index"
                    :class="{'disabled':item.type,active:item.date == checkDate,actived:item.date == checkedDate}"
                    @click="selectWeekDate(item)">
                  <p class="day">{{ item.day }}</p>
                  <p class="week">{{ item.week }}</p>
                  <p class="number">{{ item.number }}</p>
                </li>
              </ul>
              <p style="text-align: center;color: #ff976a;font-size: 2rem">已为您自动定位到最近可约日期</p>
            </dd>
          </dl>
          <div class="order-times" v-if="setBookedTime.length > 0">
            <h3>预约时间段</h3>
            <van-radio-group v-model="setBookedTimeSelected">
              <van-cell-group>
                <van-cell v-for="(item,index) in setBookedTime" v-bind:key="'setBookedTime' + index"
                          :title="item | setBookedTimeFilter"
                          clickable
                          @click="setBookedTimeClick(item)"
                          :value="item.surplus<=0?'已约满':'可约 ' + item.surplus"
                          value-class="pdr10"
                          title-style="font-weight:700"
                >
                  <template #right-icon>
                    <van-radio :name="item.id" :disabled="item.surplus<=0"/>
                  </template>
                </van-cell>
              </van-cell-group>
            </van-radio-group>
          </div>
          <van-tabs v-model="active1" color="#409EFF" sticky v-if=" bookedPatient.bookedType!=2">
            <van-tab>
              <template #title>
                套餐
                <van-badge :content="checkedPackages.length"/>
              </template>
            </van-tab>
            <van-tab
                v-if="(bookedPatient.bookedType==1 && bookedPatient.isReplaceItem != '0') || chooseGroup.length > 0">
              <template #title>
                自选项目
                <van-badge :content="chooseGroup.length"/>
              </template>
            </van-tab>
          </van-tabs>
          <div
              style="width: 100%;flex: 1; display: flex;justify-content: center;padding-bottom: 8em">
            <div style="width: 92%;margin-top: 1rem;padding-bottom: 5rem;" v-if="active1 == 0">
              <van-field name="checkbox" v-for="(item,index) in checkedPackages"
                         v-bind:key="'checkedPackages2' + index">
                <template #input>
                  <div class="package-item" @click="showDetail(item.packageId)">
                    <div style="width:50px;height: 100%;padding:5px 10px;display: flex;">
                      <img :src='item | picFilter' style="width: 50px;height: 50px;border-radius: 1rem;">
                    </div>
                    <div style="height: 100%;display: flex;flex-flow: column;justify-content: space-around;flex: 1">
                  <span style="font-weight: 700;font-size: 2.5rem;color:#171A32;">
                    {{ item.packageName }}
                  </span>
                      <!--套餐+项目和套餐允许退项结算方式显示套餐实际金额，其他显示原价金额-->
                      <p style="font-size:2rem;color: #F56C6C;">
                    <span v-if="singleShowMoney && showMoney && (settlementMode != '2' && settlementMode != '5')">
                      <em style="font-size: 1.8rem;color: #999">￥</em><strong>{{ item.price }}</strong>
                    </span>
                        <span v-if="singleShowMoney && showMoney && (settlementMode == '2' || settlementMode == '5')">
                      <em style="font-size: 1.8rem;color: #999">￥</em><strong>{{ item.actualPrice }}</strong>
                    </span>
                      </p>

                      <div style="width: 100%;display: flex;justify-content:flex-start;align-items: center;">
                        <van-tag plain color="#b9b7b7" text-color="#b9b7b7" v-if="item.sexId == '1'">男性</van-tag>
                        <van-tag plain color="#b9b7b7" text-color="#b9b7b7" v-if="item.sexId == '2'">女性</van-tag>
                        <van-tag plain color="#b9b7b7" text-color="#b9b7b7" v-if="item.sexId == '0'">通用</van-tag>

                      </div>
                    </div>
                  </div>
                  <van-button style="width: 15%;display: flex;justify-content: center;color: #9DA3A7;border: none;"
                              @click="clearPackage(item)" :disabled="item.modify == '0'?true:false">
                    <van-icon name="clear" size="4rem" color="#ff6c6c"/>
                  </van-button>
                </template>
              </van-field>
              <van-empty v-if="checkedPackages.length == 0" description="没有已选套餐"/>
            </div>
            <div style="width: 92%;margin-top: 1rem;padding-bottom: 5rem;" v-if="active1 == 1">
              <van-cell v-for="(item,index)  in chooseGroup" v-bind:key="'chooseGroup2' + index">
                <template #title>
                  <span class="custom-title">{{ (index + 1) + '、' + item.groupName }}</span>
                  <!--                  <span style="margin-left: 1rem;color: gray;">￥{{ item.actualPrice }}</span>-->
                </template>
                <template #right-icon>
                  <div v-if="!item.relevanceGroupItem">
                    <span v-if="bookedPatient.bookedType==1 && bookedPatient.isReplaceItem != '0'"
                          style="line-height: 4rem">
                      <van-icon name="clear" size="3rem" color="rgb(255, 108, 108)" style="margin-top: 1rem"
                                @click="delGroup(item)"></van-icon>
                    </span>
                  </div>
                </template>
              </van-cell>
              <van-empty v-if="chooseGroup.length == 0" description="没有加做项目"/>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <van-calendar confirm-text="选 择" title="选择体检日期" :min-date="minDate" :max-date="maxDate"
                  v-model="showDate" @confirm="selectDate" :formatter="formatter" color="#1989fa" ref="allDate"/>
    <van-popup close-icon="close" closeable v-model="showPackageDetail"
               round position="bottom" :style="{ height: '90%' }">
      <div style="width: 100%;height: 7%"></div>
      <div style="display: flex;justify-content: center;align-items: center;flex-direction: column;">
        <span style="font-size: 3rem;margin-left: 2rem;">{{ packageDetail.packageName }}</span>
        <span style="font-size: 2.3rem;color: #898989;padding: 1em;color: #576b95;">{{
            packageDetail.description
          }}</span>
      </div>
      <div style="width: 100%;height: 85%;display: flex;justify-content: center;">
        <div style="width: 96%;height: 100%;overflow-y: scroll;">
          <div v-for="(item,index) in packageDetail.basicGroupInfos" v-bind:key="'basicGroupInfos' + item.groupId">
            <van-cell center style="border-bottom: 1px solid #f5f0f0;"
                      :title-class="item.isDelete == '2'?'text-decoration':''"
                      :title=" (index + 1) + '、' + item.groupName"
                      :label="item.clinicalSignIficance | valueFilter"/>
          </div>
        </div>
      </div>
    </van-popup>
    <van-dialog v-model="showSuccess" theme="round-button" title="恭喜您，预约成功！"
                @confirm="toOrders">
      <div style="width: 100%;display: flex;margin: 3rem 0;justify-content: center;">
        <div style="width: 90%;font-size: 2.5rem;">
          <p style="text-indent:2.5rem;">您的体检订单已经生效，请于 {{ checkDate }} <span
              v-if="setBookedTimeSelectedTxt!=undefined">{{ setBookedTimeSelectedTxt }}</span> 携带身份证前往
            {{ hospitalAddress }} 进行体检。</p>
        </div>
      </div>
    </van-dialog>

    <!-- 套餐选择后提示框-->
    <van-dialog v-model="tipsShow" title="提示" v-if="portfolioTips" :before-close="tipsConfirm"
                confirm-button-text="继续">
      <html-panel :url="getPageUrl"></html-panel>
    </van-dialog>

    <!--是否前往检前问卷导航菜单-->
    <van-popup v-if="goAnswerPopShow && answerShow" v-model="popIsQuestionOrOrder"
               position="top"
               :style="{ width: '100%', height:'100%',overflow:'hidden',backgroundColor:'#F2F2F2'}">
      <div
          style="display: flex;flex-direction: column; justify-content: center;align-content: center;margin:0 15%;height: 70%;">
        <van-button round type="primary" @click="toPreconsultation">填写检前问卷</van-button>
        <van-button round v-if="!questionnaireMustShow" type="info" style="margin-top: 1.2em;"
                    @click="popIsQuestionOrOrder = false">进入体检预约
        </van-button>
      </div>
    </van-popup>
    <van-popup v-model="agreementCover" @click="agreementCover = false"
               position="bottom"
               :style="{ width: '100%', height:'100%',overflow:'hidden',backgroundColor:'#F2F2F2'}">
      <div class="wrapper" @click.stop>
        <letterConsentForm v-if="agreementCover" @update:agreementSave="handleSignatureIdUpdate"
                           :propsAgreementType="agreementType"></letterConsentForm>
      </div>
    </van-popup>
    <!--流程图提示框-->
    <van-dialog v-if=" flowChartISHOW" v-model="flowChart" theme="round-button" title="" @confirm="toOrders">
      <div class="badge-container">
        <img
            class="badge-image"
            :src="badgeImageUrl"
        />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {
  getPackageListByCompanyId,
  getGroupInfoList,
  getExcludeInfoList,
  plusGroups,
  minusGroups, getQuestionIsTrue, getQuestionnaireTypeID, getCompanyGiveGroups,
  getAgeStageIdList
} from '@/api/module/index'
import {
  getOrderCount,
  getSetBookedTime,
  getSelfCheckGroups,
  updateCompany,
  unbindingWechat,
  sendHis
} from '@/api/module/user'
import {getNextMonth, getNow, formatDate} from '@/assets/utils/dateUtil'

import {Dialog, Toast} from "vant";
import HtmlPanel from "@/components/HtmlPanel.vue";
import {decrypt, encrypt} from "@/assets/utils/cryptoUtil";
import letterConsentForm from "@/views/letterConsentForm/index.vue";
import {Decimal} from 'decimal.js';

export default {
  name: "index",
  components: {HtmlPanel, letterConsentForm},
  data() {
    return {
      singleShowMoney:true,
      showMoney: window.g.VUE_APP_SHOW_MONEY,
      VUE_APP_HIDE_MONEY_COMPANYIDS:window.g.VUE_APP_HIDE_MONEY_COMPANYIDS,
      VUE_APP_HIDE_ORDERMONEY: window.g.VUE_APP_HIDE_ORDERMONEY,
      //预约关联项目材料费附加费是否自动关联
      additionalAutoadd: window.g.VUE_APP_ADDITIONAL_AUTOADD,
      //预约 aheadDay 天
      VUE_APP_AHEAD_DAY: window.g.VUE_APP_AHEAD_DAY,
      //是否启用专病
      VUE_APP_ENABEL_SPECIFICDISEASE: window.g.VUE_APP_ENABEL_SPECIFICDISEASE,
      result: [],
      //套餐分组
      packageTypes: [],
      activePackagetype: 0,
      activePackagetypeId: '01',
      initPackageList: [],
      //套餐列表
      packageList: [],
      typeFirstSelected: 0,
      typeSecondSelected: 0,
      date: '',
      active: 0,
      active1: 0,
      show: false,
      showCheckedPackages: false,
      showChooseGroup: false,
      showChose: false,
      showPackageDetail: false,
      showDate: false,
      checkedDate: undefined,//页面传递的预约体检时间
      checkDate: undefined,//当前选择的预约体检时间
      packageDetail: {},//套餐详情数据
      packageamount: 0,//套餐总价
      total: 0,
      radio: 1,
      checkedPackages: [],//已选套餐
      checkedPackageIds: [],//已选套餐ID
      checkedPackageNames: [],//
      radio1: 1,
      checkbox: false,
      checkboxGroup: [],
      minDate: new Date(),
      maxDate: new Date(),
      //科室列表
      deptArr: [],
      //科室筛选后的加项项目
      groups: [],
      data: [],
      //所有组合项目对象
      datas: [],
      //按科室分组组合项目
      datasByDept: [],
      companyGiveGroups: [],//单位优惠组合
      //当前选中的科室名称
      checkDeptStr: '',
      //套餐组合，默认显示，默认禁止
      disableGroup: [],
      //组合排斥关联
      excludeInfoList: [],
      //排斥组合
      disabledExclude: [],
      //套餐内项目
      packageGroup: [],
      //已选加做项目
      chooseGroup: [],
      //已选加做组合价格
      groupPrice: 0,
      //预约排班
      orderCount: [],
      orderArr: new Array(),
      //可约的时间段设置
      setBookedTime: [],
      setBookedTimeSelected: undefined,
      setBookedTimeSelectedTxt: undefined,
      //登录用户信息
      user: {},
      //医院地址
      hospitalAddress: window.g.VUE_APP_ADDRESS,
      showSuccess: false,
      //父页面参数数据
      bookedPatient: {},
      //一周可预约日期
      orderWeektime: [],
      //增加项目
      showAdd: false,
      //删除项目
      showDel: false,
      //需要删除的项目ID
      delresult: [],
      //小球
      ball: {
        el: null,
        show: false,
        imgSrc: require("@/assets/images/package/package-default.jpg")
      },
      amount: 0,
      actualAmount: 0,
      discount: 1,
      selfAmount: 0,  //个人支付金额
      settlementMode: '1', //结算方式 默认按套餐
      scrollTop: 0, //自选区域初始滚动距离
      offsets: [],  //自选项目区域每个科室锚点的位置偏移量集合
      tipsShow: false,//是否显示提示框
      getPageUrl: window.g.VUE_APP_SUB_DIR + '/HtmlPanels/packageTips.html',
      //是否显示提示
      portfolioTips: window.g.VUE_APP_PORTFOLIO_TIPS,
      //选中科室后是否展示其他科室的项目
      unitOrderShow: window.g.VUE_APP_UNIT_ORDER_SHOW,
      //按性别区分显示套餐
      sexFilter: window.g.VUE_APP_ORDER_SEX_FILTER,
      // 预约成功后提示框是否显示返回列表按钮
      answerShow: false,
      // 控制是否显示前往答题的弹框
      goAnswerPopShow: window.g.VUE_APP_GO_ANSWER_POP_SHOW,
      popIsQuestionOrOrder: true,//显示是否前往填写问卷调查
      typeid: '07',//问卷类型id
      isSubmitting: false,//是否在提交预约
      // 组合项目列表
      groupList: [],
      // 同意书弹框
      agreementShow: window.g.VUE_APP_AGREEMENT_SHOW,
      // 同意书遮罩
      agreementCover: false,
      // 同意 协议类型 :妇科同意书
      agreementType: [],
      // 同意书id
      agreementSave: null,
      // 乙肝三项
      agreementYGShow: window.g.VUE_APP_AGREEMENT_YG_SHOW,
      ageStageIdArr: [],
      // 关联出的必须项目不允许直接删除开关 1 不允许 0 允许
      relevanceGroupItemDelete: window.g.VUE_APP_RELEVANCE_GROUP_ITEM_DELETE,
      flowChartISHOW: window.g.VUE_APP_ORDER_FLOW_POP,
      badgeImageUrl: '/image/hint/flowChart.jpeg', // 使用绝对路径
      flowChart: false,
      questionnaireMust: window.g.VUE_APP_PRE_QUESTIONNAIRE_MUST, // 必填问卷
      questionnaireMustShow: false,
    }
  },
  created() {
    // 20240603 ZLS 清空已选套餐
    this.checkedPackages = [];
    this.checkedPackageIds = [];

    this.user = JSON.parse(localStorage.getItem("loginuser"))
    let bookedPatient = JSON.parse(this.$route.query.item)
    this.bookedPatient = bookedPatient

    if (this.user.sexid == null || this.user.sexid == undefined || this.user.sexid == "" || this.user.sexid == "0"
        || this.user.cardid == null || this.user.cardid == undefined || this.user.cardid == ""
        || this.user.marital === "3" || this.user.marital === "4" || this.bookedPatient.marital === "3" || this.bookedPatient.marital === "4"
    ) {
      console.log("信息不全")
      Dialog.alert({
        message: "信息不全，检查性别和身份证设置，请先补全基本信息再预约",
      }).then(() => {
        this.$router.push({name: 'edituser',query:{sourcePage:"company"}})
      });
    }

    this.getAgeStageIdArr(this.bookedPatient.birthDate)
    this.getCompanyGiveGroups()
    this.getQuestionnaireTypeID()
    // 查询判断是否可以答 检前问卷
    getQuestionIsTrue({bookedNo: this.bookedPatient.bookedNo}).then(res => {
      if (res.data) {
        // 可以答题
        this.answerShow = true
      }
    }).catch(err => {
      console.log(err)
    })
    if (((this.questionnaireMust && this.questionnaireMust != '') && this.questionnaireMust == this.bookedPatient.categoryID)) {
      this.questionnaireMustShow = true
    }

    if (this.bookedPatient.bookedType == '1' || this.bookedPatient.bookedType == '3' || this.bookedPatient.bookedType == '4') {
      this.packageTypes.push({text: '基础套餐'})
    }

    if (this.VUE_APP_ENABEL_SPECIFICDISEASE && (this.bookedPatient.bookedType == '1' || this.bookedPatient.bookedType == '3')) {
      this.packageTypes.push({text: '专病套餐'})
    }

    if (bookedPatient.isReplaceItem != "0" && this.bookedPatient.bookedType == '1') {
      this.packageTypes.push({text: '自选项目'})
    }
    if (this.bookedPatient.bookedType == '2') {
      // console.log("只预约时间")
      this.showChose = true
    }
    this.checkedDate = bookedPatient.checkDate
    this.settlementMode = bookedPatient.settlementMode

    this.getGroups()
    this.getPackageList(bookedPatient.companyID, bookedPatient.companyTime)


    setTimeout(() => {
      this.getSetBookedTime(this.checkedDate)
      this.getCount()
    }, 300)
    this.$nextTick(() => {
      //元素加载完成后执行的代码
      if (this.bookedPatient.bookedType == "2") {
        this.showChecked()
      }
    });

    this.setShowMoney()

  },
  filters: {
    valueFilter: function (value) {
      if (value == null || value == '') {
        return ''
      } else {
        return value
      }
    },
    setBookedTimeFilter: function (value) {
      return value.starttime + ' ~ ' + value.endtime
    },
    filterMoney(value, showMoney) {
      if (showMoney) {
        return '（￥' + value + '）'
      } else {
        return ""
      }
    },
    settlementModeFilter: function (value) {
      switch (value) {
        case '1': {
          return "按项目"
          break;
        }
        case '2': {
          return "套餐+项目"
          break;
        }
        case '3': {
          return "单位+个人分别折扣"
          break;
        }
        case '4': {
          return "优惠固定金额"
          break;
        }
        case '5': {
          return "套餐（允许退项）"
          break;
        }
      }
    }
  },
  computed: {
    // 计算滚动高度
    computedScrollHeight() {
      const container = this.$el.querySelector('.plur-item-main');
      return container.scrollHeight;
    }
  },
  methods: {
    //计算showMoney的值
    setShowMoney(){
      if(this.showMoney){
        if(Array.isArray(this.VUE_APP_HIDE_MONEY_COMPANYIDS)){
          if(this.VUE_APP_HIDE_MONEY_COMPANYIDS.includes(this.bookedPatient.companyID.substring(0,4))){
            this.singleShowMoney = false
          }
        }
      }
    },
    setItemRef(index) {
      return "depta-" + index
    },
    getItemRef(index) {
      return this.$refs["depta-" + index]
    },
    //小球飞入购物车特效
    beforeEnter(el) {
      let ele = this.ball.el //要添加购物车的商品
      let ract = ele.getBoundingClientRect() //商品的位置
      let elRight = this._getStyle(el, 'right') //购物车 right
      let elTop = this._getStyle(el, 'top') //购物车 top
      let x = ract.left - 30 // 计算小球移动的X轴的距离
      let y = window.innerHeight - ract.top - 30// 计算小球移动的y轴的距离

      el.style.display = ''
      el.style.transform = `translateX(${x}px)` //重置小球的x轴位置

      let innerBall = el.querySelector('.innerBall')
      innerBall.style.transform = `translateY(-${y}px)`//重置小球的y轴位置
    },
    enter(el, done) {
      let ele = this.ball.el //要添加购物车的商品
      let ract = ele.getBoundingClientRect() //商品的位置
      let x = ract.left // 计算小球移动的X轴的距离
      let y = window.innerHeight - ract.top - 100// 计算小球移动的y轴的距离
      this._offset = document.body.offsetHeight //激发重绘

      el.style.transform = `translateX(-${x}px)` //重置小球的x轴位置
      let innerBall = el.querySelector('.innerBall')
      innerBall.style.transform = `translateY(${y}px)`//重置小球的y轴位置
      el.addEventListener('transitionend', done)
    },
    afterEnter(el) {
      this.ball.show = false
      el.style.display = 'none'
    },
    _getStyle(el, attr) {
      return el.currentStyle
          ? el.currentStyle[attr]
          : getComputedStyle(el, false)[attr]
    },
    //套餐类别切换
    navClick(index) {
      let packageList = [];
      const selectText = this.packageTypes[this.activePackagetype].text.substring(0, 4)
      if (selectText === '基础套餐') {
        this.activePackagetypeId = '01'
        let basicPackagSelectArr = this.checkedPackages.filter((item) => {
          return item.packageType == '01'
        })
        let baseCheckedCount = false;
        this.checkedPackages.some(jtem => {
          if (jtem.packageType == '01') {
            baseCheckedCount = true
            return true;
          }
        })
        this.initPackageList.forEach(item => {
          if (item.packageType == '01') {
            if (baseCheckedCount) {
              this.checkedPackages.forEach(jtem => {
                if (item.packageType == '01') {
                  if (item.packageId == jtem.packageId) {
                    item.isSelected = true
                  }
                  // 去除重复的套餐:如果是重复套餐则不添加进列表
                  if (!packageList.find(etem => etem.packageId == item.packageId)) {
                    // 客户婚姻状况是已婚或离异的匹配套餐通用和已婚
                    // 增加年龄段筛选 2025-10-18 luotong
                    if((this.bookedPatient.marital == "1" || this.bookedPatient.marital == "2")
                        && (item.marriage == "0" || item.marriage == "1")
                        && (item.ageStageId == "000" || this.ageStageIdArr.includes(item.ageStageId))
                    ){
                      packageList.push(item)
                    }
                    // 客户婚姻状况是未婚的匹配套餐通用和未婚
                    // 增加年龄段筛选 2025-10-18 luotong
                    if(this.bookedPatient.marital == "0"
                        && (item.marriage == "0" || item.marriage == "2")
                        && (item.ageStageId == "000" || this.ageStageIdArr.includes(item.ageStageId))
                    ){
                      packageList.push(item)
                    }
                  }
                }
              })
            } else {
              this.checkedPackages.forEach(jtem => {
                if (item.packageType == '01' && item.packageId == jtem.packageId) {
                  item.isSelected = true
                }
              })
              if (item.packageType == '01') {
                // 客户婚姻状况是已婚或离异的匹配套餐通用和已婚
                // 增加年龄段筛选 2025-10-18 luotong
                if((this.bookedPatient.marital == "1" || this.bookedPatient.marital == "2")
                    && (item.marriage == "0" || item.marriage == "1")
                    && (item.ageStageId == "000" || this.ageStageIdArr.includes(item.ageStageId))
                ){
                  packageList.push(item)
                }
                // 客户婚姻状况是未婚的匹配套餐通用和未婚
                // 增加年龄段筛选 2025-10-18 luotong
                if(this.bookedPatient.marital == "0"
                    && (item.marriage == "0" || item.marriage == "2")
                    && (item.ageStageId == "000" || this.ageStageIdArr.includes(item.ageStageId))
                ){
                  packageList.push(item)
                }
              }
            }
          }
        })
        this.packageTypes[this.getPackageTypeIndex(selectText)].text = '基础套餐(' + packageList.length + ')'
      }
      if (selectText === '专病套餐') {
        this.activePackagetypeId = '02'
        this.initPackageList.forEach(item => {
          console.log("item.packageType",item.packageType)
          console.log("this.bookedPatient.marital",this.bookedPatient.marital)
          console.log("item.marriage",item.marriage)
          if (item.packageType == '02') {
            // 客户婚姻状况是已婚或离异的匹配套餐通用和已婚
            // 增加年龄段筛选 2025-10-18 luotong
            if((this.bookedPatient.marital == "1" || this.bookedPatient.marital == "2")
                && (item.marriage == "0" || item.marriage == "1")
                && (item.ageStageId == "000" || this.ageStageIdArr.includes(item.ageStageId))
            ){
              packageList.push(item)
            }
            // 客户婚姻状况是未婚的匹配套餐通用和未婚
            // 增加年龄段筛选 2025-10-18 luotong
            if(this.bookedPatient.marital == "0"
                && (item.marriage == "0" || item.marriage == "2")
                && (item.ageStageId == "000" || this.ageStageIdArr.includes(item.ageStageId))
            ){
              packageList.push(item)
            }
          }
        })
        this.packageTypes[this.getPackageTypeIndex(selectText)].text = '专病套餐(' + packageList.length + ')'
      }
      this.$nextTick(() => {
        this.packageList = packageList
      })
      //自选项目
      if (selectText === '自选项目') {
        this.showAdd = true
        this.checkDept(0, this.checkDeptStr)
        this.packageTypes[this.getPackageTypeIndex(selectText)].badge = this.chooseGroup.length
        this.getOffsets();
      } else {
        this.showAdd = false
      }
      this.computeAmount()
    },
    // 匹配套餐类型 返回下标
    getPackageTypeIndex(packageType) {
      let index = -1
      this.packageTypes.forEach((item, i) => {
        if (item.text.substring(0, 4) == packageType) {
          index = i
        }
      })
      return index
    },
    //移除已选套餐
    clearPackage(obj) {
      console.log(obj)
      if (obj.packageType == "01") {
        this.typeFirstSelected--
        if (this.getPackageTypeIndex('基础套餐') >= 0) {
          this.packageTypes[this.getPackageTypeIndex('基础套餐')].badge = this.typeFirstSelected
        }
      }
      if (obj.packageType == "02") {
        this.typeSecondSelected--
        if (this.getPackageTypeIndex('专病套餐') >= 0) {
          this.packageTypes[this.getPackageTypeIndex('专病套餐')].badge = this.typeSecondSelected
        }
      }
      obj.isSelected = false
      let clearIdx = this.checkedPackageIds.findIndex(item => item === obj.packageId)
      let clearIndex = this.checkedPackages.findIndex(item => item === obj)
      let clearIdxN = this.checkedPackageNames.findIndex(item => item === obj.packageName)
      this.checkedPackages.splice(clearIndex, 1)
      this.checkedPackageIds.splice(clearIdx, 1)
      this.checkedPackageNames.splice(clearIdxN, 1)
      if (this.checkedPackages.length == 1) {
        this.checkedPackages.forEach(item => {
          item.basicGroupInfos.forEach(jtem => {
            jtem.isDelete = "0"
          })
        })
      }
      this.computeAmount()
      this.cancelExcludePackage(obj)
      //移除已选基础套餐后，显示出所有基础套餐
      this.navClick()
    },
    //查询加做项目
    getSelfCheck() {
      let _this = this
      let param = {
        bookedNo: this.bookedPatient.bookedNo
      }
      getSelfCheckGroups(param).then(res => {
        if (res.code == 200) {
          let selectedGroups = res.data.map(obj => {
            // 使用解构赋值来创建新的对象，其中 groupID 被重命名为 groupId
            return {
              ...obj, // 复制所有其他属性
              groupId: obj.groupID // 重命名 groupID 为 groupId
            };
          });
          selectedGroups.forEach(item => {
            this.result.push(item.groupId)
          })
          //设置数据库中已选自选项目
          this.chooseGroup = this.groups.filter(item => _this.result.includes(item.groupId));
        }
      })
    },
    //查询预约排班
    getCount() {
      let _this = this;
      let companyid = this.bookedPatient.companyID;
      if (companyid.length > 4) {
        companyid = companyid.substring(0, 7)
      } else {
        companyid = companyid.substring(0, 4)
      }
      let params = {
        companyid: companyid,
        companytimes: this.bookedPatient.companyTime,
        checkline: this.bookedPatient.enterQueue,
        institutionid: window.g.VUE_APP_INSTITUTIONID
      }
      getOrderCount(params).then(res => {
        if (res.code == 200) {
          this.orderCount = res.data
          let currDatetime = ""
          let currDatetimeIsCount = false
          //定义一个变量，提前预约天数
          let nextDay = new Date(_this.getNow());
          console.log("时间问题：nextMonthStr", nextDay);
          this.orderCount.forEach(item => {
            if (item.womennumber > 0 || item.mennumber > 0) {
              if (item.womennumber - item.alreadywomen > 0 || item.mennumber - item.alreadymen > 0) {
                if (!currDatetimeIsCount && item.bookeddate > nextDay) {
                  currDatetime = item.bookeddate
                  currDatetimeIsCount = true
                }
              }
            } else if (item.bookednumber > 0) {
              if (item.bookednumber - item.already > 0) {
                if (!currDatetimeIsCount && item.bookeddate > nextDay) {
                  currDatetime = item.bookeddate
                  currDatetimeIsCount = true
                }
              }
            }
            _this.orderArr.push(item.bookeddate + '')
          })
          _this.maxDate = getNextMonth()
          setTimeout(function () {
            if (currDatetime == "") {
              _this.orderWeektime = _this.getWeekTime()
            } else {
              _this.orderWeektime = _this.getWeekTime(currDatetime)
            }
            // 2024-02-28 ZLS 查询当前日期列表 是否有可预约的日期 有则自动选择当前日期
            _this.orderWeektime.some(item => {
              if (!item.type) {
                _this.selectWeekDate(item);
                return true;
              }
            })
          }, 30)
        }
      })
    },
    checkGroup(group) {
      if (/(?=.*?液基)(?=.*?TCT)/g.test(group.groupName) || group.groupName.indexOf("HPV") != -1
          || group.groupName.indexOf("妇科") != -1 || group.groupName.indexOf("阴道分泌物") != -1) {
        //判断是选择还是取消
        if (this.result.includes(group.groupId)) {
          console.log("取消")
          Dialog.confirm({
            title: '温馨提示',
            message: '没有性生活史禁止检查',
          })
              .then(() => {
                // on confirm
                this.checkGroupAfter(group)
              })
              .catch(() => {
                // on cancel
                this.result.splice(this.result.findIndex(n => n === group.groupId), 1)
              });
        } else {
          console.log("选择")
          this.checkGroupAfter(group)
        }
      } else {
        this.checkGroupAfter(group)
      }
    },
    //选择组合
    checkGroupAfter(group) {
      //是否禁用
      if (this.disableGroup.includes(group.groupId)) {
        return;
      }
      //取消
      if (!this.result.includes(group.groupId)) {
        this.delGroup(group)
      }
      //选择
      else {
        //判断性别是否合适 sexId
        let userSex = this.user.sexid
        if (group.sexId == '1') {
          //男
          if (userSex == '0') {
            Dialog.alert({
              title: '提示',
              message: '您选择的组合适用性别与您的性别不符合',
            }).then(() => {
              // on close
            });
            //取消选择的这个组合
            this.result.splice(this.result.findIndex(i => i === group.groupId), 1)
            return
          }
        } else if (group.sexId == '2') {
          //女
          if (userSex == '1') {
            Dialog.alert({
              title: '提示',
              message: '您选择的组合适用性别与您的性别不符合',
            }).then(() => {
              // on close
            });
            //取消选择的这个组合
            this.result.splice(this.result.findIndex(i => i === group.groupId), 1)
            return
          }
        }
        //禁用排斥项
        this.exclude()
        this.chooseGroup.push(group)
        //将关联的项目勾上
        //根据组合ID查询关联项目
        let strArr = new Array();
        this.excludeInfoList.forEach(item => {
          if (item.groupId == group.groupId) {
            if (item.dependGroupList.length > 0) {
              item.dependGroupList.forEach(jtem => {

                if (!this.result.includes(jtem.relationGroupId)) {
                  //关联项目判断是否存在已选的套餐中
                  let isExistPackageGroups = false;
                  this.checkedPackages.forEach(ptem => {
                    ptem.basicGroupInfos.forEach(gtem => {
                      if (gtem.groupId == jtem.relationGroupId) {
                        isExistPackageGroups = true
                        return false
                      }
                    })
                  })
                  //判断材料费附加费是否需要关联自动添加
                  if (this.additionalAutoadd) {
                    if (!isExistPackageGroups && jtem.mandatory == '1') {
                      let gArr = this.groups.filter(n => n.groupId == jtem.relationGroupId)
                      if (gArr.length > 0) {
                        this.result.push(jtem.relationGroupId)
                        this.chooseGroup.push(gArr[0])
                        strArr.push(jtem.relationGroupName)
                      }
                    }
                  } else {
                    if (!isExistPackageGroups && jtem.itemType != '8' && jtem.itemType != '9' && jtem.mandatory == '1') {
                      //这里需要处理下，relationGroupId可能未匹配到项目this.groups，因有些项目不显示或者禁用
                      let gArr = this.groups.filter(n => n.groupId == jtem.relationGroupId)
                      if (gArr.length > 0) {
                        this.result.push(jtem.relationGroupId)
                        this.chooseGroup.push(gArr[0])
                        strArr.push(jtem.relationGroupName)
                      }
                    }
                  }
                }
              })
            }
          }
        })
        if (strArr.length > 0) {
          if (group.wechatTips && this.result.includes(group.groupId)) {
            Dialog.alert({
              title: '项目提示',
              message: group.wechatTips,
            }).then(() => {
              Dialog.alert({
                title: '追加关联项目:',
                message: strArr.join(" 、"),
              }).then(() => {
                // on close
              });
            })
          } else {
            Dialog.alert({
              title: '追加关联项目:',
              message: strArr.join(" 、"),
            }).then(() => {
              // on close
            });
          }
        } else {
          if (this.result.includes(group.groupId)) {
            if (group.wechatTips) {
              Dialog.alert({
                title: '项目提示',
                message: group.wechatTips,
              })
            }
          }
        }
      }
      if (this.getPackageTypeIndex('自选项目') >= 0) {
        this.packageTypes[this.getPackageTypeIndex('自选项目')].badge = this.result.length
      }
      setTimeout(() => {
        this.computeAmount()
      }, 300)
      console.log("选择组合", this.result)
      if (this.relevanceGroupItemDelete == "1") {
        this.relevanceGroupItem()
      }
    },
    // 关联出的必选组合项目设置不准操作;如果加做项目list中没有被关联的项目则允许
    relevanceGroupItem() {
      this.chooseGroup.forEach(groupItem => {
        this.excludeInfoList.forEach(excludeItem => {
          if (groupItem.groupId === excludeItem.groupId) {
            excludeItem.dependGroupList?.forEach(dependency => {
              this.chooseGroup.forEach(relatedGroup => {
                // 强制必选的组合项目不能操作
                if (dependency.relationGroupId == relatedGroup.groupId && dependency.mandatory == 1) {
                  relatedGroup = this.ensureRelevanceGroupItem(relatedGroup, dependency);
                  console.log("relatedGroup", relatedGroup)
                }
              });
            });
          }
        });
      });
    },
    ensureRelevanceGroupItem(group, dependency) {
      if (!Array.isArray(group.relevanceGroupItem)) {
        this.$set(group, 'relevanceGroupItem', []);
      }

      if (!group.relevanceGroupItem.includes(dependency.groupID)) {
        group.relevanceGroupItem.push(dependency.groupID);
      }
      return group;
    },
    // 判断当前项目是强制关联则不能操作 不能主动删除只能被 关联删除
    estimateRelevanceGroupItem(item) {
      if (!item || !Array.isArray(this.chooseGroup)) {
        return false;
      }

      return this.chooseGroup.some(groupItem => {
        return item.groupId === groupItem.groupId && groupItem.relevanceGroupItem;
      });
    },
    getExcludes() {
      let params = {
        sexid: this.user.sexid
      }
      getExcludeInfoList(params).then(res => {
        if (res.code == 200) {
          this.excludeInfoList = res.data
          //默认的也要⛏
          this.exclude()
          // 20240910 ZLS 新增 获取到排斥项目直接开始过滤
          this.excludePackage()
        }
      })
    },
    //选择套餐
    checkPackage(item, event) {
      if (item.packageType == "01") {
        if (this.typeFirstSelected >= 1) {
          Toast("基础套餐最多只能选一个")
          return
        }
      }
      //套餐项目是否重复
      let repPackageGroup = this.isRepPackageGroup(item);
      if (repPackageGroup.length > 0) {
        let groupNames = []
        repPackageGroup.forEach(item => {
          groupNames.push(item.groupName)
        })
        Dialog.confirm({
          title: '套餐项目重复提示',
          message: '以下项目：\t\n' + groupNames.join(',') + '\r\n和已选的套餐项目重复了，是否继续？',
          confirmButtonText: '继续',
          confirmButtonColor: '#07c160'
        }).then(() => {
          this.checkPackageFn(item)
        }).catch(() => {
          //取消
        })
      } else {
        this.checkPackageFn(item)
      }
    },
    checkPackageFn(item) {
      this.disableGroup = []
      let total = 0;
      this.packageamount = 0;

      let userSex = this.user.sexid
      if (item.sexId == '1') {
        if (userSex == '0') {
          Toast("该套餐性别不符合")
          return
        }
      } else if (item.sexId == '2') {
        if (userSex == '1') {
          Toast("该套餐性别不符合")
          return
        }
      }

      if (item.packageType == "01") {
        if (this.typeFirstSelected >= 1) {
          Toast("基础套餐最多只能选一个")
          return
        } else {
          this.typeFirstSelected++
          if (this.getPackageTypeIndex('基础套餐') >= 0) {
            this.packageTypes[this.getPackageTypeIndex('基础套餐')].badge = this.typeFirstSelected
          }
        }
      }


      if (item.packageType == "02") {
        this.typeSecondSelected++
        if (this.getPackageTypeIndex('专病套餐') >= 0) {
          this.packageTypes[this.getPackageTypeIndex('专病套餐')].badge = this.typeSecondSelected
        }
      }
      item.isSelected = true
      //设置小球对象是当前点击对象
      this.ball.el = event.target
      this.ball.show = true
      //设置小球的图片为套餐的图片
      this.ball.imgSrc = event.currentTarget.parentElement.firstElementChild.firstElementChild.firstElementChild.getAttribute('src')

      this.checkedPackageIds.push(item.packageId)
      this.checkedPackageNames.push(item.packageName)
      item.modify = '1'
      this.checkedPackages.push(item)
      this.isRepChooseGroup()
      this.excludePackage()
      setTimeout(() => {
        this.computeAmount()
      }, 300)
    },
    isRepPackageGroup(currentCheckPackage) {
      let repGroupInfos = []
      this.checkedPackages.forEach((item, i) => {
        item.basicGroupInfos.forEach(gtem => {
          currentCheckPackage.basicGroupInfos.forEach(jtem => {
            if (gtem.groupId == jtem.groupId) {
              //已选套餐中有重复项目
              repGroupInfos.push(jtem)
            }
          })
        })
      })
      return repGroupInfos
    },
    //判断套餐项目是否和自选项目重复，返回重复项目数组
    isRepChooseGroup() {
      let _this = this
      let repGroupInfos = []
      if (this.checkedPackages.length > 0) {
        let isRepChooseGroup = false
        this.checkedPackages.forEach((item, i) => {
          item.basicGroupInfos.forEach(gtem => {
            _this.result.forEach(r => {
              if (gtem.groupId == r) {
                //已选套餐中有重复项目
                repGroupInfos.push(gtem)
              }
            })
          })
        })
      }

      if (repGroupInfos.length > 0) {
        Dialog.alert({
          title: '温馨提示',
          message: '因套餐内已含以下项目，以下自选项将被移除：\r\n' + repGroupInfos.map(item => item.groupName).join("\r\n"),
          confirmButtonText: '确定',
          confirmButtonColor: '#07c160'
        }).then(() => {
          // console.log("_this.result",_this.result)
          // console.log("repGroupInfos",repGroupInfos)
          // //更新选中自选项ID数组
          // _this.result = _this.result.filter((r) => {
          //   return !repGroupInfos.some((item)=> item.groupId == r)
          // })
          // console.log("_this.result",_this.result)
          // //更新选中自选项对象数组
          // this.$nextTick(() => {
          //   _this.chooseGroup = _this.chooseGroup.filter((g) => {
          //     return !repGroupInfos.some((item)=> item.groupId == g.groupId)
          //   })
          //   this.packageTypes[this.getPackageTypeIndex('自选项目')].badge = _this.chooseGroup.length
          //   _this.computeAmount()
          // })
          repGroupInfos.forEach((group) => {
            _this.packageSelectDelGroup(group)
          })
        })
      }
    },
    packageSelectDelGroup(group) {
      //删除项目
      this.chooseGroup = this.chooseGroup.filter(item => {
        return item.groupId != group.groupId
      })
      this.result.splice(this.result.findIndex(i => i === group.groupId), 1)
      if (this.getPackageTypeIndex('自选项目') >= 0) {
        this.packageTypes[this.getPackageTypeIndex('自选项目')].badge = this.chooseGroup.length
      }
      setTimeout(() => {
        this.computeAmount()
      }, 300)
    },
    getGroups() {
      let param = {
        institutionId: window.g.VUE_APP_INSTITUTIONID,
        companyid: this.bookedPatient.companyID,
        companytime: this.bookedPatient.companyTime
      }
      getGroupInfoList(param).then(res => {
        if (res.code == 200) {
          this.groupList = res.data
          //根据科室进行分类
          let userSex = this.user.sexid
          res.data.forEach(item => {
            if (!this.deptArr.includes(item.departmentName) && item.departmentName != undefined && item.isEnable == "1" && item.serviceShow != '2') {
              if (userSex == '2') {
                if (item.sexId != '1') {
                  this.deptArr.push(item.departmentName)
                }
              } else if (userSex == '1') {
                if (item.sexId != '2') {
                  this.deptArr.push(item.departmentName)
                }
              } else {
                this.deptArr.push(item.departmentName)
              }
            }
            if (item.isEnable == "1" && item.serviceShow != '2') {
              //针对万康除台州银行外其他单位不显示该项目
              if (item.groupID == '5622') {
                if (this.bookedPatient.companyid == '0046') {
                  this.groups.push(item);
                }
              } else {
                this.groups.push(item);
              }
            }
          })

          this.datasByDept = this.groupByDept(this.groups)
          this.checkDeptStr = this.datasByDept[0].departmentName
          //查询加做项目
          this.getSelfCheck();
        }
      })
    },
    //返回更新单位优惠金额的组合项目
    companyGivePrice(group) {
      this.companyGiveGroups.forEach(item => {
        if (item.groupid == group.groupId) {
          group.price = item.favorableprice
          group.actualPrice = item.favorableprice
        }
      })
      return group
    },
    //获取单位优惠组合
    getCompanyGiveGroups() {
      let param = {
        companyid: this.bookedPatient.companyID,
        companytimes: this.bookedPatient.companyTime
      }
      getCompanyGiveGroups(param).then(res => {
        if (res.code == 200) {
          this.companyGiveGroups = res.data
        }
      })
    },
    // 获取套餐列表
    getPackageList(companyId, companyTimes) {
      let param = {
        companyId: companyId,
        companyTimes: companyTimes
      }
      if (this.getPackageTypeIndex('专病套餐') < 0 && this.getPackageTypeIndex('基础套餐') < 0) {
        this.showAdd = true
      } else {
        getPackageListByCompanyId(param).then(res => {
          console.log("this.ageStageIdArr", this.ageStageIdArr)
          this.user = JSON.parse(localStorage.getItem("loginuser"))
          let bookedPatient = JSON.parse(this.$route.query.item)
          this.bookedPatient = bookedPatient
          if (this.user.sexid == null || this.user.sexid == undefined || this.user.sexid == "" || this.user.sexid == "0"
              || this.user.cardid == null || this.user.cardid == undefined || this.user.cardid == ""
              || this.user.marital === "3" || this.user.marital === "4" || this.bookedPatient.marital === "3" || this.bookedPatient.marital === "4"
          ) {
            Dialog.alert({
              message: "信息不全，检查性别和身份证设置，请先补全基本信息再预约",
            }).then(() => {
              this.$router.push({name: 'edituser',query:{sourcePage:"company"}})
            });
          }

          if (res.code == 200) {
            let userSex = this.bookedPatient.sexID
            let marital = this.bookedPatient.marital
            res.data.forEach(item => {
              item.price = decrypt(item.priceStr)
              item.actualPrice = decrypt(item.actualPriceStr)
            })
            this.initPackageList = res.data.filter((item) => {
              /* 性别、婚姻匹配、离异算已婚，下面是判断逻辑
              * 1、性别相等或者套餐性别通用和客户性别为未说明
              * 2、未婚：套餐婚姻未婚或者通用
              * 3、已婚、离异：套餐婚姻已婚或者通用
              * 4、未说明
              */
              return (item.sexId == userSex || item.sexId == '0' || userSex == "0")
                  && ((marital == "0" && (item.marriage == "2" || item.marriage == '0')) || ((marital == "1" || marital == "2") && (item.marriage == "1" || item.marriage == '0')) || marital == "3")
            })

            let bookedpackageList = this.bookedPatient.bookedpackageList
            let packageList = [];
            let basicPackageSelected = 0
            if (bookedpackageList != null && bookedpackageList.length == 1) {
              this.initPackageList.forEach(item => {
                if (item.packageType == '01') {
                  bookedpackageList.forEach(jtem => {
                    if (item.packageId == jtem.packageid) {
                      console.log("item", item)
                      console.log("jtem", jtem)
                      item.modify = jtem.modify
                      item.isSelected = true
                      this.checkedPackages.push(item)
                      this.checkedPackageIds.push(item.packageId)
                      this.checkedPackageNames.push(item.packageName)
                      this.typeFirstSelected++
                      if (this.getPackageTypeIndex('基础套餐') >= 0) {
                        this.packageTypes[this.getPackageTypeIndex('基础套餐')].badge = this.typeFirstSelected
                      }
                      packageList.push(item)
                    }
                  })
                }
              })
            } else if (bookedpackageList != null && bookedpackageList.length > 1) {
              this.initPackageList.forEach(item => {
                if (item.packageType == '01' && (this.bookedPatient.bookedType == '1' || this.bookedPatient.bookedType == '3' || this.bookedPatient.bookedType == '4')) {
                  bookedpackageList.forEach(jtem => {
                    if (item.packageId == jtem.packageid) {
                      item.modify = jtem.modify
                      item.isSelected = true
                      this.checkedPackages.push(item)
                      this.checkedPackageIds.push(item.packageId)
                      this.checkedPackageNames.push(item.packageName)
                      this.typeFirstSelected++
                      if (this.getPackageTypeIndex('基础套餐') >= 0) {
                        this.packageTypes[this.getPackageTypeIndex('基础套餐')].badge = this.typeFirstSelected
                      }
                    }
                  })
                  packageList.push(item)
                }
                if (item.packageType == '02' && (this.bookedPatient.bookedType == '1' || this.bookedPatient.bookedType == '3')) {
                  bookedpackageList.forEach(jtem => {
                    if (item.packageId == jtem.packageid) {
                      item.modify = jtem.modify
                      item.isSelected = true
                      this.checkedPackages.push(item)
                      this.checkedPackageIds.push(item.packageId)
                      this.checkedPackageNames.push(item.packageName)
                      this.typeSecondSelected++
                      if (this.getPackageTypeIndex('专病套餐') >= 0) {
                        this.packageTypes[this.getPackageTypeIndex('专病套餐')].badge = this.typeSecondSelected
                      }
                    }
                  })
                }
              })
            } else {
              this.initPackageList.forEach(item => {
                if (item.packageType == '01') {
                  packageList.push(item)
                }
              })
            }

            this.packageList = packageList
            if (packageList.length <= 0) {
              this.initPackageList.forEach(item => {
                if (item.packageType == '01') {
                  packageList.push(item)
                }
              })
            }
            this.packageList = packageList

            this.checkedPackages = this.sortByKey(this.checkedPackages, 'modify', true)

            /*控制一级列表 */
            if (this.bookedPatient.bookedType == '1' || this.bookedPatient.bookedType == '3' || this.bookedPatient.bookedType == '4') {
              if (this.getPackageTypeIndex('基础套餐') >= 0) {
                this.packageTypes[this.getPackageTypeIndex('基础套餐')].text = '基础套餐(' + this.packageList.length + ')'
              }
            }

            //选择这个客户导入的套餐
            this.getExcludes()
            this.checkDept(0, this.checkDeptStr)
            this.computeAmount()
          }
        })
      }
    },
    //数组排序 array 数组 key  字段 order true 升序 false  降序
    sortByKey(array, key, order) {
      return array.sort(function (a, b) {
        var x = a[key];
        var y = b[key]
        if (order) {
          return ((x < y) ? -1 : ((x > y) ? 1 : 0))
        } else {
          return ((x < y) ? ((x > y) ? 1 : 0) : -1)
        }
      })
    },
    getOffsets() {
      this.$nextTick(() => {
        const elements = document.querySelectorAll('.grouplist');
        elements.forEach(el => {
          this.offsets.push({
            offsetTop: el.offsetTop
          });
        });
      });
    },
    //自选项目区域滚动事件
    handleScroll(event) {
      this.offsets.forEach((item, index) => {
        //当前滚动的位置 event.target.scrollTop
        if (event.target.scrollTop >= item.offsetTop) {
          this.checkDeptStr = this.deptArr[index]
          return false
        }
      })
    },
    checkDept(index, checkDeptStr) {
      let refs = this.getItemRef(index)
      if (refs && refs.length > 0) {
        refs[0].scrollIntoView()
      }
      this.checkDeptStr = checkDeptStr

      // 用于不显示其他科室项目的时候用

      this.datasByDept.forEach(item => {
        if (item.departmentName == checkDeptStr) {
          item.items = item.groupMains
          // 按首字母排序
          item.groupMains.sort((a, b) => {
            if (a.pinYin && b.pinYin) {
              return a.pinYin.localeCompare(b.pinYin, 'en')
            }
          })
          // 按首字母排序
          item.items.sort((a, b) => {
            if (a.pinYin && b.pinYin) {
              return a.pinYin.localeCompare(b.pinYin, 'en')
            }
          })
        } else {
          item.items = []
        }
      })
      this.checkSex()
      this.exclude()
    },
    //按科室分组
    groupByDept(arr) {
      let keys = Object.keys(arr[0])
      let level1 = 'departmentName' //获取一级属性名称
      let list = Array.from(new Set(
          arr.map(item => {
            return item[level1]
          })))
      let subList = []
      list.forEach(res => {
        arr.forEach(ele => {
          if (ele[level1] === res) {
            let nameArr = subList.map(item => item.departmentName)
            if (nameArr.indexOf(res) !== -1) {
              subList[nameArr.indexOf(res)].groupMains.push({
                ...ele
              })

            } else {
              subList.push({
                departmentName: res,
                // label: res,
                groupMains: [{
                  ...ele
                }]
              })
            }
          }
        })

      })
      return subList
    },
    showPopup() {
      this.show = true
    },
    showDetail(id) {
      //通过套餐ID查询套餐详情
      this.showPackageDetail = true
      this.initPackageList.forEach(item => {
        if (item.packageId == id) {
          this.packageDetail = item
        }
      })
      this.$nextTick(function () {
        if (this.packageDetail != null) {
          if (this.packageDetail.basicGroupInfos != undefined) {
            this.total = this.packageDetail.basicGroupInfos.length
          }
        }
      })
    },
    detail(item) {
      if (item != '') {
        Dialog.alert({
          title: '检查意义',
          message: item,
        }).then(() => {
        });
      }
    },
    showChecked() {
      if (!this.portfolioTips) {
        let _this = this;
        setTimeout(function () {
          _this.computeAmount()
        }, 300)
        this.showChose = true
      } else {
        this.tipsShow = true
      }

    },
    //数组根据字段去重
    uniqueByField(arr, field) {
      const seen = new Set();
      return arr.filter((item) => {
        const key = item[field];
        return seen.has(key) ? false : seen.add(key);
      });
    },
    //计算金额
    computeAmount() {
      //查看已经选择的组合
      this.groupPrice = 0
      //加做组合
      //获取加做组合详情 chooseGroup
      this.groups.forEach(item => {
        this.chooseGroup.forEach(jtem => {
          if (item.groupId == jtem.groupId) {
            //加做组合价格 groupPrice
            this.groupPrice = parseFloat(this.groupPrice) + parseFloat(item.price)
          }
        })
      })
      this.packageamount = 0

      let amount = 0 //原价总金额
      let amountDiscount = 0 //实收总金额（结算方式134）
      let actualAmount = 0;
      let unitQuota = this.bookedPatient.unitQuota
      if (isNaN(unitQuota)) {
        unitQuota = 0
      }

      let packagePrice = parseFloat(this.bookedPatient.packagePrice)
      if (isNaN(packagePrice) || parseInt(packagePrice) == 0) {
        packagePrice = unitQuota
      }
      let discount = parseFloat(this.bookedPatient.discount)
      let selfAmount = 0
      let unDiscountItems = []
      let discountItems = []
      let unDiscountPrice = 0
      let prevBasicGroupInfos = this.chooseGroup
      let deductionAmount = 0
      this.checkedPackages.forEach((item, i) => {
        this.packageamount += parseFloat(item.actualPrice)
        item.basicGroupInfos.forEach(gtem => {
          //判断是否重复
          let b = false
          if (prevBasicGroupInfos.length > 0) {
            prevBasicGroupInfos.forEach(jtem => {
              if (gtem.groupId == jtem.groupId) {
                gtem.isDelete = '2'
                deductionAmount += gtem.price
                b = true
                return false
              }
            })
          }

          //如果不重复
          if (!b) {
            if (gtem.isDelete == "2") {
              gtem.isDelete = "0"
            }
          }
          if (gtem.isDelete == "2") {

          } else {
            switch (this.bookedPatient.settlementMode) {
                //按项目
              case '1':
              case '3':
              case '4': {
                let gtemT = this.companyGivePrice(gtem)
                amount += parseFloat(gtemT.price)
                if (gtem.allowDiscount == "1" && gtem.isDelete != "2") {
                  amountDiscount += parseFloat(gtemT.price) * discount
                } else {
                  amountDiscount += parseFloat(gtemT.price)
                }
                break
              }
              default: {
                amount += parseFloat(gtem.price)
              }
            }

          }

          if (gtem.allowDiscount == "1" && gtem.isDelete != "2") {
            discountItems.push(gtem)
          } else {
            unDiscountItems.push(gtem)
            unDiscountPrice += gtem.price
          }
        })
        prevBasicGroupInfos = prevBasicGroupInfos.concat(item.basicGroupInfos)
      })

      //套餐总金额
      this.packageamount = this.packageamount - deductionAmount
      this.chooseGroup.forEach(item => {
        amount += item.price
        switch (this.bookedPatient.settlementMode) {
            //按项目
          case '1':
          case '3':
          case '4': {
            let gtemT = this.companyGivePrice(item)
            if (item.allowDiscount == "1") {
              amountDiscount += parseFloat(gtemT.price) * discount
            } else {
              amountDiscount += parseFloat(gtemT.price)
            }
            break
          }
          default: {
            amountDiscount += parseFloat(item.price)
          }
        }
        if (item.allowDiscount == "1") {
          discountItems.push(item)
        } else {
          unDiscountItems.push(item)
          unDiscountPrice += item.price
        }
      })
      switch (this.bookedPatient.settlementMode) {
          //按项目
        case '1':
        case '4': {
          selfAmount = amountDiscount - packagePrice
          this.selfAmount = selfAmount.toFixed(2)
          actualAmount = (unitQuota + selfAmount).toFixed(2)

          //计算实际折扣
          let realDiscount = (actualAmount - unDiscountPrice) / (amount - unDiscountPrice)
          if (isNaN(realDiscount)) {
            realDiscount = 1
          }
          console.log("实际折扣：" + realDiscount)

          this.updateGroupsPrice(realDiscount) //更新项目实收价格
          this.floatingGroupsPrice() //抹平价差
          break;
        }
          //套餐+项目
        case '2':
        case '5': {
          //如果未设置项目配额->按套餐+项目
          selfAmount = this.packageamount + (this.groupPrice * discount) - unitQuota
          this.selfAmount = selfAmount.toFixed(2)
          actualAmount = (unitQuota + selfAmount).toFixed(2)
          console.log('更新价格前：' + selfAmount)
          console.log('更新价格前：' + actualAmount)
          this.updatePackageGroupsPrice() //更新套餐项目实收价格
          this.floatingPackageGroupsPrice() //抹平套餐价差
          break;
        }
          //单位+个人分别折扣
        case '3': {
          if (isNaN(packagePrice)) {
            packagePrice = unitQuota
          }
          selfAmount = (amount - packagePrice) * discount
          this.selfAmount = selfAmount.toFixed(2)
          actualAmount = (unitQuota + selfAmount).toFixed(2)

          //计算实际折扣
          let realDiscount = (actualAmount - unDiscountPrice) / (amount - unDiscountPrice)
          console.log("实际折扣：" + realDiscount)

          this.updateGroupsPrice(realDiscount) //更新项目实收价格
          this.floatingGroupsPrice() //抹平价差
          break;
        }
      }
      this.amount = amount.toFixed(2)
      this.actualAmount = actualAmount
      this.discount = discount

      // console.log("结算方式：" + this.bookedPatient.settlementMode)
      // console.log("原价金额：" + this.amount)
      // console.log("实收金额：" + this.actualAmount)
      // console.log("套餐金额：" + this.packageamount)
      // console.log("加做金额：" + (this.groupPrice * discount).toFixed(2))
      // console.log("单位支付：" + unitQuota)
      // console.log("项目配额：" + packagePrice)
      // console.log("自付金额：" + this.selfAmount)
      this.checkGroupsPrice() //验证项目实收价格
    },
    updatePackageGroupsPrice() {
      // 更新套餐项目实收价格
      if (!this.checkedPackages || this.checkedPackages.length === 0) return;

      this.checkedPackages.forEach(item => {
        let notAllowDiscountAmount = new Decimal(0);

        item.basicGroupInfos.forEach(gtem => {
          if (gtem.allowDiscount !== "1" || gtem.isDelete === "2") {
            notAllowDiscountAmount = notAllowDiscountAmount.plus(new Decimal(gtem.price || 0));
          }
        });

        const totalAmount = new Decimal(item.price || 0).minus(notAllowDiscountAmount);
        const actualTotalAmount = new Decimal(item.actualPrice || 0).minus(notAllowDiscountAmount);

        let realDiscount = new Decimal(1);
        if (!totalAmount.isZero()) {
          realDiscount = actualTotalAmount.div(totalAmount);
        }

        item.basicGroupInfos.forEach(gtem => {
          if (gtem.allowDiscount === "1" && gtem.isDelete !== "2") {
            gtem.actualPrice = realDiscount.times(new Decimal(gtem.price || 0)).toFixed(2);
          }
        });
      });

      // 更新加做项目的实收金额
      if (!this.chooseGroup || this.chooseGroup.length === 0) return;

      let chooseGroupTotal = new Decimal(0);
      let maxItem = null;
      let maxTotal = new Decimal(0);

      this.chooseGroup.forEach(item => {
        if (item.allowDiscount === "1") {
          const price = new Decimal(item.price || 0);
          item.actualPrice = price.times(this.discount || 1).toFixed(2);
          chooseGroupTotal = chooseGroupTotal.plus(new Decimal(item.actualPrice));

          const actualPrice = new Decimal(item.actualPrice);
          if (actualPrice.gt(maxTotal)) {
            maxTotal = actualPrice;
            maxItem = item;
          }
        }
      });

      const actualGroupPrice = new Decimal(this.groupPrice || 0).times(this.discount || 1).toFixed(2);
      const diff = new Decimal(actualGroupPrice).minus(chooseGroupTotal).toFixed(2);

      if (diff !== '0') {
        if (maxItem) {
          maxItem.actualPrice = new Decimal(maxItem.actualPrice).plus(new Decimal(diff)).toFixed(2);
        }
      }
    },

    //抹平套餐价差
    floatingPackageGroupsPrice() {
      this.checkedPackages.forEach(item => {
        let actualAmount = 0;
        let notAllowDiscountAmount = 0
        let maxIndex = 0
        let maxPrice = 0
        item.basicGroupInfos.forEach((gtem, i) => {
          if (gtem.allowDiscount == "1" && gtem.isDelete != "2") {
            actualAmount += parseFloat(gtem.actualPrice)
            if (parseFloat(gtem.actualPrice) > maxPrice) {
              maxPrice = parseFloat(gtem.actualPrice)
              maxIndex = i
            }
          } else {
            notAllowDiscountAmount += parseFloat(gtem.price)
          }
        })
        if (actualAmount != parseFloat(item.actualPrice - notAllowDiscountAmount)) {
          let diff = parseFloat(item.actualPrice - notAllowDiscountAmount) - actualAmount
          let tempPrice = item.basicGroupInfos[maxIndex].actualPrice;
          item.basicGroupInfos[maxIndex].actualPrice = parseFloat(tempPrice) + diff
        }
      })


    },
    //更新项目实收价格
    updateGroupsPrice(realDiscount) {
      this.checkedPackages.forEach((item, i) => {
        item.basicGroupInfos.forEach(gtem => {
          if (gtem.allowDiscount == "1" && gtem.isDelete != "2") {
            gtem.actualPrice = (gtem.price * realDiscount).toFixed(2)
          }
        })
      })
      this.chooseGroup.forEach(item => {
        if (item.allowDiscount == "1") {
          item.actualPrice = (item.price * realDiscount).toFixed(2)
        }
      })
    },
    //抹平价差
    floatingGroupsPrice() {
      let actualAmount = 0
      let maxIndex = 0
      let maxPrice = 0
      let flag = 0
      let pIndex = 0
      this.checkedPackages.forEach((item, pi) => {
        item.basicGroupInfos.forEach((gtem, i) => {
          if (gtem.isDelete != "2") {
            actualAmount += parseFloat(gtem.actualPrice)
            if (parseFloat(gtem.actualPrice) > maxPrice) {
              maxPrice = parseFloat(gtem.actualPrice)
              maxIndex = i
              pIndex = pi
            }
          }
        })
      })
      this.chooseGroup.forEach((item, i) => {
        actualAmount += parseFloat(item.actualPrice)
        if (parseFloat(item.actualPrice) > maxPrice) {
          maxPrice = parseFloat(item.actualPrice)
          maxIndex = i
          flag = 1
        }
      })
      //抹平价差
      if (parseFloat(this.actualAmount) != actualAmount) {
        let diff = parseFloat(this.actualAmount) - actualAmount
        console.log("actualAmount：" + actualAmount)
        console.log("价差：" + diff)
        if (flag == 0) {
          this.checkedPackages.forEach((item, pi) => {
            if (pi == pIndex) {
              item.basicGroupInfos.forEach((gtem, i) => {
                if (i == maxIndex) {
                  gtem.actualPrice = (parseFloat(gtem.actualPrice) + diff).toFixed(2)
                }
              })
            }
          })
        } else {
          this.chooseGroup.forEach((item, i) => {
            if (i == maxIndex) {
              item.actualPrice = (parseFloat(item.actualPrice) + diff).toFixed(2)
            }
          })
        }
      }
    },
    //验证项目实收价格
    checkGroupsPrice() {
      let actualAmount = 0
      this.checkedPackages.forEach((item, pi) => {
        item.basicGroupInfos.forEach((gtem, i) => {
          if (gtem.isDelete != "2") {
            actualAmount += parseFloat(gtem.actualPrice)
          }
        })
      })
      this.chooseGroup.forEach((item, i) => {
        actualAmount += parseFloat(item.actualPrice)
      })
      // console.log("验证实收金额：" + actualAmount.toFixed(2))
    },
    delGroup(group) {
      console.log("删除组合项目：" + group.groupId)
      // 查询当前项目ID是否有关联项目  2024-7-11 ZLS 修改删除逻辑; 当前组合项目有关联项目 则把关联项目从自选列表中剔除
      let ExcludeArr = new Array()
      this.excludeInfoList.forEach(item => {
        if (item.groupId == group.groupId) {
          item.dependGroupList.forEach(jtem => {
            // 筛选出当前组合项目ID 关联的组合项目ID并且在自选列表中
            if (this.result.includes(jtem.relationGroupId) && jtem.mandatory == "1") {
              ExcludeArr.push(jtem.relationGroupId)
            }
          })
        }
      })
      // 20250923 筛选出自选列表中关联项目 查询当前被排除的组合项目ID是否强关联多个组合项目 是则剔除不允许删除
      ExcludeArr = this.getExcludeInfoList(ExcludeArr)
      console.log("关联项目id", ExcludeArr)
      var ExcludeName = [];
      this.groupList.forEach(item => {
        if (ExcludeArr.includes(item.groupId)) {
          ExcludeName.push(item.groupName)
        }
      })
      Dialog.confirm({
        message: ExcludeName.length > 0 ? '【' + group.groupName + '】 关联 【' + ExcludeName.join('  、') + '】，确定要删除吗？' : '您确定要删除 【' + group.groupName + '】 项目吗？',
      }).then(() => {
        //删除项目
        console.log("删除的关联的组合id", ExcludeArr)
        // 20250909 zls 判断当前项目是否在列表中 不在则不需要删除
        if (this.result.findIndex(i => i === group.groupId) !== -1) {
          console.log("删除的组合id", this.result.findIndex(i => i === group.groupId))
          this.result.splice(this.result.findIndex(i => i === group.groupId), 1)
        }
        this.chooseGroup = this.chooseGroup.filter(item => {
          return item.groupId != group.groupId
        })
        //删除关联项目
        ExcludeArr.forEach(jtem => {
          this.result.splice(this.result.findIndex(i => i === jtem), 1)
          this.chooseGroup = this.chooseGroup.filter(item => {
            return item.groupId != jtem
          })
        })
        if (this.getPackageTypeIndex('自选项目') >= 0) {
          this.packageTypes[this.getPackageTypeIndex('自选项目')].badge = this.chooseGroup.length
        }
      }).catch(() => {
        //如果点击了取消则复选框需要选回去
        this.result.push(group.groupId)
      }).finally(() => {
        // 20250909 zls 增加 finally保证上面执行后才执行这里实时更新价格
        setTimeout(() => {
          this.computeAmount()
        }, 300)
      })
    },
    // 查询当前被排除的组合项目ID是否强关联多个组合项目
    getExcludeInfoList(ExcludeArr) {
      console.log("关联项目id2", ExcludeArr)
      var ExcludeArrList = [];
      for (const ExcludeId in ExcludeArr) {
        this.chooseGroup.forEach(atem => {
          if (atem.groupId != ExcludeArr[ExcludeId]) {
            this.excludeInfoList.forEach(item => {
              if (item.groupId == atem.groupId) {
                console.log("关联项目id3", item.groupId, item)
                item.dependGroupList.forEach(jtem => {
                  // 筛选出当前组合项目ID 关联的组合项目ID并且在自选列表中
                  if (jtem.mandatory == "1" && jtem.relationGroupId == ExcludeArr[ExcludeId]) {
                    ExcludeArrList.push(jtem.relationGroupId)
                  }
                })
              }
            })
          }
        })
      }
      console.log("关联项目id4", ExcludeArrList)
      // 如果能匹配到多个则剔除 如果只有一个则保留
      if (ExcludeArrList.length > 1) {
        // 使用Map统计每个元素出现的次数
        const countMap = new Map();
        ExcludeArrList.forEach(id => {
          countMap.set(id, (countMap.get(id) || 0) + 1);
        });

        // 只保留出现次数为1的元素
        ExcludeArr = ExcludeArr.filter(item => {
          return countMap.get(item) === 1;
        });
      }
      return ExcludeArr
    },
    //将已选择的组合的排斥项禁用掉
    exclude() {
      //已选组合排斥，禁止
      this.groups.forEach(item => {
        if (this.result.includes(item.groupId)) {
          //获取组合的排斥项目
          this.excludeInfoList.forEach(jtem => {
            if (jtem.groupId == item.groupId) {
              //科室下面的每个组合，查出排斥项目
              if (jtem.excludeGroupList.length > 0) {

                //所有的禁用项目
                jtem.excludeGroupList.forEach(i => {
                  // console.log("排他项目",i.relationGroupName)
                  if (!this.disabledExclude.includes(i.relationGroupId)) {
                    this.disabledExclude.push(i.relationGroupId)
                  }
                  if (!this.disableGroup.includes(i.relationGroupId)) {
                    this.disableGroup.push(i.relationGroupId)
                  }
                })
              }
            }
          })
        }
      })
    },
    //将套餐项目的排他项目禁用
    excludePackage() {
      this.checkedPackages.forEach(p => {
        p.basicGroupInfos.forEach(item => {
          //获取组合的排斥项目
          this.excludeInfoList.forEach(jtem => {
            if (jtem.groupId == item.groupId) {
              //科室下面的每个组合，查出排斥项目
              if (jtem.excludeGroupList.length > 0) {
                //所有的禁用项目
                jtem.excludeGroupList.forEach(i => {
                  if (!this.disabledExclude.includes(i.relationGroupId)) {
                    this.disabledExclude.push(i.relationGroupId)
                    //取消选择的这个组合
                    this.result.splice(this.result.findIndex(i => i === i.relationGroupId), 1)
                    this.chooseGroup = this.chooseGroup.filter(item => {
                      return item.groupId != i.relationGroupId
                    })
                  }
                  if (!this.disableGroup.includes(i.relationGroupId)) {
                    this.disableGroup.push(i.relationGroupId)
                  }
                })
              }
            }
          })
        })
      })
      if (this.getPackageTypeIndex('自选项目') >= 0) {
        this.packageTypes[this.getPackageTypeIndex('自选项目')].badge = this.chooseGroup.length
      }
      setTimeout(() => {
        this.computeAmount()
      }, 300)
    },
    //根据字段删除数组元素
    removeElementByField(array, field, value) {
      return array.filter(item => item[field] !== value);
    },
    //移除套餐的时候把之前禁用的项目恢复
    cancelExcludePackage(p) {
      p.basicGroupInfos.forEach(item => {
        //获取组合的排斥项目
        this.excludeInfoList.forEach(jtem => {
          if (jtem.groupId == item.groupId) {
            //科室下面的每个组合，查出排斥项目
            if (jtem.excludeGroupList.length > 0) {
              //所有的禁用项目
              jtem.excludeGroupList.forEach(i => {
                // console.log("恢复排他项目",i.relationGroupName)
                if (this.disabledExclude.includes(i.relationGroupId)) {
                  this.disabledExclude.splice(this.disabledExclude.findIndex(j => j === i.relationGroupId), 1)
                }
                if (this.disableGroup.includes(i.relationGroupId)) {
                  this.disableGroup.splice(this.disableGroup.findIndex(j => j === i.relationGroupId), 1)
                }
              })
            }
          }
        })
      })
    },
    formatter(day) {
      let year = day.date.getFullYear();
      let month = day.date.getMonth() + 1;
      let date = day.date.getDate();
      if (month < 10) {
        month = '0' + month
      }
      if (date < 10) {
        date = '0' + date
      }
      let days = year + '-' + month + '-' + date
      this.orderCount.forEach(item => {
        if (item.bookeddate == days) {
          if (item.status == '0') {
            day.bottomInfo = '不可约';
            day.type = "disabled"
          } else if (item.status == '1') {
            let personCount = 0;
            if (parseInt(item.mennumber) > 0 || parseInt(item.womennumber) > 0) {
              if (this.user.sexid == "1") {
                personCount = parseInt(item.mennumber) - parseInt(item.alreadymen);
              }
              if (this.user.sexid == "2") {
                personCount = parseInt(item.womennumber) - parseInt(item.alreadywomen);
              }
            } else {
              personCount = parseInt(item.bookednumber) - parseInt(item.already);
            }
            if (personCount <= 0) {
              day.bottomInfo = '已约满';
              day.type = "disabled"
            } else {
              if (days < this.getNow()) {
                day.type = "disabled"
                day.bottomInfo = '不可约';
              } else {
                day.bottomInfo = '余 ' + personCount;
              }

            }
          }
        }
      })
      //将所有的没有排期的设置为休息日
      if (!this.orderArr.includes(days)) {
        let nextMonthStr = ""
        let nextMonth = getNextMonth()
        let nextM = nextMonth.getMonth() + 1
        let nextD = nextMonth.getDate()
        if (nextM < 10) {
          nextM = '0' + nextM
        }
        if (nextD < 10) {
          nextD = '0' + nextD
        }
        nextMonthStr = nextMonth.getFullYear() + '-' + nextM + '-' + nextD
        //已经过去的时间不显示文字
        if (days >= getNow() && days <= nextMonthStr) {
          // console.log(days)
          day.bottomInfo = '不可约';
          day.type = "disabled"
        }
      }
      return day;
    },
    selectDate(date) {
      let newDate = new Date()
      this.showDate = false
      if (formatDate(date) == formatDate(new Date())) {
        return;
      }
      this.checkDate = formatDate(date)
      this.orderWeektime = this.getWeekTime(this.checkDate)
      // console.log("体检日期" + this.checkDate)
      this.getSetBookedTime(this.checkDate)
    },
    setBookedTimeClick(item) {
      if (item.surplus > 0) {
        this.setBookedTimeSelected = item.id
        this.setBookedTimeSelectedTxt = item.starttime + " ~ " + item.endtime
      }
    },
    selectWeekDate(item) {
      if (item.type) {
        return;
      }
      // console.log(item);
      this.checkDate = item.date
      this.$refs.allDate.reset(new Date(this.checkDate));
      this.getSetBookedTime(this.checkDate)
    },
    getNow() {
      let d = new Date();
      d.setDate(d.getDate() + 1)
      if (this.VUE_APP_AHEAD_DAY != null) {
        d.setDate(d.getDate() + (parseInt(this.VUE_APP_AHEAD_DAY) - 1))
      }
      let yy1 = d.getFullYear();
      let mm1 = d.getMonth() + 1;
      if (mm1 < 10) {
        mm1 = '0' + mm1
      }
      let dd1 = d.getDate();
      if (dd1 < 10) {
        dd1 = '0' + dd1
      }
      return yy1 + '-' + mm1 + '-' + dd1
    },
    getWeekTime(dateParam) {
      // var new_Date = new Date(2021,11,10) //获取指定日期当周的一周日期
      var new_Date = new Date() //获取本周一周日期
      if (this.orderArr.length > 0) {
        new_Date = new Date(this.orderArr[0])
      }
      if (dateParam != undefined) {
        new_Date = new Date(dateParam)
      }
      var timesStamp = new_Date.getTime();
      var currenDay = new_Date.getDay();
      var dates = [];
      for (var i = 0; i < 7; i++) {
        var das = new Date(timesStamp + 24 * 60 * 60 * 1000 * (i - (currenDay + 6) % 7));
        // var dasStr = das.toLocaleDateString();
        let year = das.getFullYear();
        let month = das.getMonth() + 1;
        let date = das.getDate();
        if (month < 10) {
          month = '0' + month
        }
        if (date < 10) {
          date = '0' + date
        }
        let days = year + '-' + month + '-' + date
        var weekObj = {};
        weekObj.index = i
        weekObj.date = days;
        // das.replace(/[年月]/g, '.').replace(/[日上下午]/g, '');
        weekObj.day = (das.getMonth() + 1) + '/' + das.getDate();
        weekObj.week = this.getWeekName(das.getDay());
        weekObj.type = true;
        weekObj.number = '不可约'
        if (das.getDay() == 6 || das.getDay() == 0) {
          weekObj.type = true;
          weekObj.number = '不可约'
        }
        if (this.orderArr.length > 0) {
          this.orderCount.forEach(item => {
            if (item.bookeddate == days) {
              if (item.status == '0') {
                weekObj.number = '不可约'
                weekObj.type = true
              } else if (item.status == '1') {
                let personCount = 0;
                if (parseInt(item.mennumber) > 0 || parseInt(item.womennumber) > 0) {
                  if (this.user.sexid == "1") {
                    personCount = parseInt(item.mennumber) - parseInt(item.alreadymen);
                  }
                  if (this.user.sexid == "2") {
                    personCount = parseInt(item.womennumber) - parseInt(item.alreadywomen);
                  }
                } else {
                  personCount = parseInt(item.bookednumber) - parseInt(item.already);
                }
                if (personCount <= 0) {
                  weekObj.number = '已约满';
                  weekObj.type = true
                } else {
                  if (days < this.getNow()) {
                    weekObj.type = true
                    weekObj.number = '不可约';
                  } else {
                    weekObj.type = false
                    weekObj.number = '余 ' + personCount;
                  }

                }
              }
            }
          })
        }
        dates.push(weekObj);
      }
      return dates;
    },
    getWeekName(day) {
      switch (day) {
        case 1: {
          return "周一";
          break;
        }
        case 2: {
          return "周二";
          break;
        }
        case 3: {
          return "周三";
          break;
        }
        case 4: {
          return "周四";
          break;
        }
        case 5: {
          return "周五";
          break;
        }
        case 6: {
          return "周六";
          break;
        }
        case 0: {
          return "周日";
          break;
        }
        default: {
          return "";
        }
      }
    },
    //将不适用性别的组合禁用掉
    checkSex() {
      this.disableGroup = []
      //判断性别是否适用
      let userSex = this.user.sexid
      if (userSex == "2") {
        //女
        //过滤男性组合
        this.groups.forEach(item => {
          if (item.sexId == '1' && item.sexId != '0') {
            this.disableGroup.push(item.groupId)
          }
        })
      } else if (userSex == "1") {
        //男
        //过滤女性组合
        this.groups.forEach(item => {
          if (item.sexId == '2' && item.sexId != '0') {
            this.disableGroup.push(item.groupId)
          }
        })
      }
      //将套餐内包含的项目禁用掉
      this.groups.forEach(item => {
        this.checkedPackages.forEach(jtem => {
          jtem.basicGroupInfos.forEach(ktem => {
            if (item.groupId == ktem.groupId) {
              this.disableGroup.push(item.groupId)
            }
          })
        })
      })
    },
    //清空已选项目
    clearGroups() {
      Dialog.confirm({
        title: '提示',
        message: '您确定要清空已选加做项目吗？',
      }).then(() => {
        Toast('已清空已选加做项目');
        this.result = []
        this.chooseGroup = []
        if (this.getPackageTypeIndex('自选项目') >= 0) {
          this.packageTypes[this.getPackageTypeIndex('自选项目')].badge = 0
        }
        this.computeAmount()
      }).catch(() => {
        // on cancel
      });
    },
    //预约
    orderNow() {
      if (this.checkDate == undefined) {
        Toast.fail('请选择体检日期');
        return
      }
      if (this.setBookedTime.length > 0 && this.setBookedTimeSelected == undefined) {
        Toast.fail('请选择体检时间段');
        return
      }
      if (this.bookedPatient.bookedType != 2 && this.checkedPackages.length <= 0 && this.chooseGroup.length <= 0) {
        Toast.fail('您还未选择项目，请先选择');
        return
      }
      //2024-03-16 luotong 判断基础套餐是否有选择
      let basicPackageCount = 0
      this.checkedPackages.forEach(item => {
        if (item.packageType == "01") {
          basicPackageCount++
        }
      })
      //针对万康的先注释，不然无法提交，因可以不选套餐
      if (this.bookedPatient.bookedType != 2 && basicPackageCount <= 0) {
        Toast.fail('基础套餐至少选择一个，请选择后再提交！');
        return
      }
      if (this.agreementShow || this.agreementYGShow) {
        this.showAgreement()
      } else {
        this.makeOrder()
      }

    },
    //查询预约时间段
    getSetBookedTime(bookedDate) {
      if (bookedDate != null) {
        bookedDate = bookedDate.replace(RegExp("-", "g"), "")
        let params = {
          bookedDate: bookedDate,
          checkLine: this.bookedPatient.enterQueue,
          institutionId: window.g.VUE_APP_INSTITUTIONID
        }
        getSetBookedTime(params).then(res => {
          if (res.code == 200) {
            this.setBookedTime = res.data
          }
        })
      }
    },
    //提交前去除重复项
    removeDuplicatesById(arr) {
      const ids = [];
      return arr.filter(obj => {
        if (ids.includes(obj.groupId)) {
          return false;
        }
        ids.push(obj.groupId);
        return true;
      })
    },
    //添加订单
    makeOrder() {
      let chooseGroup = this.removeDuplicatesById(this.chooseGroup)
      this.chooseGroup = chooseGroup
      this.computeAmount()
      let checkedPackages = this.checkedPackages

      let companyid = this.bookedPatient.companyID
      let companytime = this.bookedPatient.companyTime

      let param = {
        itemmode: '3',
        bookedno: this.bookedPatient.bookedNo,
        sexid: this.bookedPatient.sexID,
        checkdate: this.checkDate,
        timeslot: this.setBookedTimeSelected,
        patientid: this.user.patientid,
        amt: encrypt(this.actualAmount),
        amount: this.actualAmount,
        packageid: this.checkedPackageIds[0],
        packagename: this.checkedPackageNames.join(","),
        packageamount: this.packageamount,
        companyid: companyid,
        companytime: companytime,
        enterqueue: this.bookedPatient.enterQueue,
        bookednos: this.bookedPatient.bookedNos,
        hospitaladdress: this.hospitalAddress,
        institutionid: window.g.VUE_APP_INSTITUTIONID,
        chooseGroup,
        checkedPackages,
        agreementSave: this.agreementSave,
      }
      if (parseFloat(this.actualAmount) < parseFloat(this.bookedPatient.unitQuota) && this.bookedPatient.bookedType != 2) {
        Dialog.confirm({
          title: '温馨提示',
          message: '金额未超出单位支付，可继续添加项目，是否继续提交？',
        })
            .then(() => {
              this.isSubmitting = true
              // on confirm
              //确认预约，修改加做项目和体检日期，不添加订单
              updateCompany(param).then(res => {
                this.isSubmitting = false

                console.log("res.data.deptCestriction", res.data.deptCestriction)
                if (res.data.deptCestriction) {
                  Dialog.alert({
                    title: '温馨提示',
                    message: res.data.deptCestriction,
                  })
                }

                if (res.code == 200) {
                  if (res.data == 0) {
                    Dialog.alert({
                      title: '温馨提示',
                      message: res.msg,
                    }).then(() => {
                      if (res.msg.indexOf("抱歉，用户信息未查询到，") != -1) {
                        this.loginOut()
                      }
                    });
                  } else {
                    if (res.data != null && res.data.serialno != "") {
                      this.sendHisOrder(res.data.serialno)
                    }
                    this.showSuccess = true
                  }
                }
              })
            })
            .catch(() => {
              // on cancel
            });
      } else {
        // console.log("提交订单", param)
        this.isSubmitting = true
        updateCompany(param).then(res => {
          this.isSubmitting = false

          console.log("res.data.deptCestriction", res.data.deptCestriction)
          if (res.data.deptCestriction) {
            Dialog.alert({
              title: '温馨提示',
              message: res.data.deptCestriction,
            })
          }

          if (res.code == 200) {
            if (res.data == 0) {
              Dialog.alert({
                title: '温馨提示',
                message: res.msg,
              }).then(() => {
                if (res.msg.indexOf("抱歉，用户信息未查询到，") != -1) {
                  this.loginOut()
                }
              });
            } else {
              if (res.data != null && res.data.serialno != "") {
                this.sendHisOrder(res.data.serialno)
              }
              this.showSuccess = true
            }
          }
        })
      }
    },
    sendHisOrder(serialno) {
      let param = {
        serialno: serialno
      }
      if (serialno) { // ZLS 20241009 添加判断是否有流水号
        sendHis(param).then(res => {

        })
      }
    },
    //跳转
    toOrders() {
      // 判断是否弹出流程图提示 20250922 增加判断修复跳转问题
      if (!this.flowChart && this.flowChartISHOW) {
        this.flowChart = true
        return
      }
      // ZLS 20240816 companyOrders 改为 Orders
      this.$router.push({name: 'orders'})
    },
    getQuestionnaireTypeID() {
      let params = {
        typename: "体检检前问卷"
      }
      getQuestionnaireTypeID(params).then(res => {
        if (res.code == 200) {
          this.typeid = res.data
        }
      })
    },
    toPreconsultation() {
      this.$router.push({
        name: 'preconsultationDetail',
        query: {
          id: null,
          serialno: null,
          bookedNo: this.bookedPatient.bookedNo,
          typeid: this.typeid,
          pageName: 'companyOrder',
          pageParams: this.$route.query.item
        }
      })
    },
    loginOut() {
      //如果有用户信息，则不进行微信登录
      let userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
      let params = {
        wechatid: ""
      }
      if (userinfo != undefined) {
        params = {
          wechatid: userinfo.openid
        }
      }
      unbindingWechat(params).then(res => {
        if (res.code == 200) {
          // Toast("解绑成功！")
          window.localStorage.removeItem("loginuser")
          localStorage.removeItem("token")
          this.$router.push({name: 'login'})
        }
      })
    },
    // tips 确认按钮
    tipsConfirm(action, done) {
      if (action === 'confirm') {
        done();
      } else {
        done();
      }
      let _this = this;
      setTimeout(function () {
        _this.computeAmount()
      }, 300)
      this.showChose = true
    },
    // 弹出同意书
    showAgreement() {
      this.agreementType = []
      if (this.FKAgreement() && this.agreementShow) {
        this.agreementType.push('2')
      }
      if (this.YGAgreement() && this.agreementYGShow) {
        this.agreementType.push('3')
      }
      let extend = this
      if (this.agreementType.length > 0) {
        Dialog.confirm({
          title: '温馨提示',
          message: '请签署同意书',
          confirmButtonText: '去签署',
          cancelButtonText: '取消预约'
        }).then(() => {
          extend.agreementCover = true
          console.log('fkFlag', extend.agreementCover)
        })
      } else {
        this.makeOrder();
      }

    },
    // 循环判断是否有乙肝三系项目
    YGAgreement() {
      let ygFlag = false;
      this.checkedPackages.forEach(item => {
        item.basicGroupInfos.forEach(gtem => {
          console.log("yg", this.checkedPackages)
          if (gtem.groupName.indexOf(this.agreementYGShow) != -1) {
            console.log("有需要签署同意书的乙肝三系套餐")
            ygFlag = true;
          }
        })
      })
      // 筛选乙肝三系项目
      this.chooseGroup.forEach(item => {
        if (item.groupName.indexOf(this.agreementYGShow) != -1) {
          console.log("有需要签署同意书的乙肝三系项目")
          ygFlag = true;
        }
      })
      return ygFlag
    },
    FKAgreement() {
      const user = JSON.parse(localStorage.getItem("loginuser"));
      if (user.sexid == '1') { // 如果性别是男性进
        return
      }
      if (user.marital !== '0' && user.marital != '3') {// 筛选婚姻状态 非未知和未婚状态都进入
        return
      }
      // 如果是已婚套餐不签署
      let fkFlag = true;
      // 判断套餐的婚姻状态
      let marriage = false
      this.checkedPackages.forEach(item => {
        if (item.marriage == '1') {
          fkFlag = false
        } else if (item.marriage == '2') {
          fkFlag = true
        } else {
          fkFlag = true
          marriage = true
        }
      })
      if (!fkFlag) {
        return
      }

      //判断套餐内是否有妇科相关项目
      // this.checkedPackages.forEach(item => {
      //   item.basicGroupInfos.forEach(gtem => {
      //     if (gtem.gynaecology == "1") {
      //       console.log("有需要签署同意书的妇科套餐")
      //       fkFlag = true;
      //     }
      //   })
      // })
      // 判断套餐的婚姻状态 为未知；没加项则不签署
      fkFlag = false;
      console.log("套餐无婚姻状态")
      // 筛选妇科项目
      this.chooseGroup.forEach(item => {
        console.log("项目妇科相关状态", item.gynaecology)
        if (item.gynaecology == "1") {
          console.log("有需要签署同意书的妇科项目")
          fkFlag = true;
        }
      })
      return fkFlag;
    },
    handleSignatureIdUpdate(agreementSave) {
      this.agreementCover = false
      this.agreementSave = agreementSave
      this.makeOrder();
    },
    // 获取年龄阶段
    async getAgeStageIdArr(birthdate){
      let param = {
        birthdate: birthdate,
        forCount: "2"
      }
      console.log("获取年龄阶段", param)
      getAgeStageIdList(param).then(res => {
        this.ageStageIdArr = res.data
      })
    }
  }
}
</script>

<style scoped>
.main {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  background: #F5F5F5;
}

.package {
  width: 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  /*margin-bottom: 10rem;*/
  /*margin-top: 1.5rem;*/
}

.package-item {
  width: 100%;
  /*height: 12rem;*/
  background: #fff;
  border-radius: 10px;
  margin-bottom: 1.5rem;
  display: flex;
  flex-flow: row;
  justify-content: center;
  /*box-shadow: 0 0 1.5rem #f5f5f5;*/
}

.group {
  width: 100%;
  margin-top: 1rem;
  padding-bottom: 10rem;
}

.footer {
  width: 100%;
  position: absolute;
  bottom: 0;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;
  z-index: 99;
}


.active1 {
  background-image: linear-gradient(to right, #10E3E9, #409EFF);
  color: #fff;
}

.van-cell {
  padding: 1rem;
}

.van-cell__title {
  font-size: 2.2rem;
}

.plur-item-side {
  border-top-left-radius: 2rem;
  border-bottom-left-radius: 2rem;
}

.plur-item-main {
  border-top-right-radius: 2rem;
}

.plur-item-side .van-cell-group {
  background-color: #ecf1f5;
}

.plur-item-side .van-cell {
  background-color: transparent
}

.plur-item-side .van-cell-group.active {
  /*background-image: linear-gradient(to right, #10E3E9, #409EFF);*/
  background-color: #fff;
  color: #000;
  font-weight: bold;
  position: relative;
}

.plur-item-side .van-cell-group.active .van-cell {
  color: #000;
}

.plur-item-side .van-cell-group.active:before, .plur-item-side .van-cell-group.active:after {
  content: ' ';
  position: absolute;
  background: #ecf1f5;
  width: 1.2rem;
  height: 1.2rem;
  right: 0;
  z-index: 2;
  display: block;
}

.plur-item-side .van-cell-group.active:before {
  top: -1.2rem;
  border-bottom-right-radius: 100%;
}

.plur-item-side .van-cell-group.active:after {
  bottom: -1.2rem;
  border-top-right-radius: 100%;
}

.corner {
  width: 1.2rem;
  height: 1.2rem;
  position: absolute;
  background: #fff;
}

.bottom-corner {
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 1;
}

.top-corner {
  position: absolute;
  bottom: 100%;
  right: 0;
}

.plur-item-side .van-cell:after {
  border-bottom: none;
}

.plur-item-side .van-cell {
  color: #737171;
}

.van-popup {
  background-clip: padding-box;
}

.order-dates {
  background: #fff;
  margin-top: 0.5rem;
}

.order-dates dt {
  font-size: 2rem;
  font-weight: bold;
  padding: 1.5rem;
  display: flex;
  font-weight: 500;
}

.order-dates dt .dt-right {
  font-size: 2.2rem;
  color: #969799;
}

.order-dates dt h3 {
  flex: 1;
}

.order-dates h3 {

}

.order-dates dd {
  padding-bottom: 1.5rem;
}

.order-dates ul {
  display: flex;
  font-size: 1.6rem;
  margin-left: 1rem;
  margin-right: 1rem;
}

.order-dates ul li {
  flex: 1;
  margin: 0 .3rem;
  background: #f1f5f9;
  text-align: center;
  padding-bottom: 1rem;
  border-radius: 1.5rem;
}

.order-dates ul li p {
  margin-top: .5rem;
  margin-bottom: .5rem;
}

.order-dates ul .day {
  color: gray;
}

.order-dates ul .week {
  font-size: 2rem;
  font-weight: bold;
}

.order-dates ul li.disabled .day, .order-dates ul li.disabled .week, .order-dates ul li.disabled .number {
  color: #d0d0d0;
}

.order-dates ul li.active {
  background-color: #1989fa;
}

.order-dates ul li.active .day, .order-dates ul li.active .week, .order-dates ul li.active .number {
  color: #fff;
}

/*预约日期是小于等于当天的不能约*/
.order-dates ul li.actived {
  background-color: #d5e1f9;
}

.order-times {
  margin-top: .2em;
  font-size: 2em;
  background: #f7f8fa;
  padding: 0 1em 1em 1em;
}

.order-times h3 {
  padding: 1.5rem 0;
}

.pdr10 {
  padding-right: 1em;
  text-align: left;
  font-size: .8em
}

.van-tree-select {
  width: 100%;
}

.van-tree-select__content {
  height: calc(100vh - 8rem);
  flex: 5;
}

.van-sidebar-item {
  font-weight: 700;
}


.ball {
  position: fixed;
  bottom: 40px;
  left: 40px;
  width: 2rem;
  height: 2rem;
  transition: all 1000ms cubic-bezier(0.000, 0.600, 0.940, 0.270);
  z-index: 9;
}

.innerBall {
  width: 2rem;
  height: 2rem;
  transition: all 1s linear;
}

.text-decoration span:first-child {
  text-decoration: line-through;
  color: #ff6c6c;
}

/*选择套餐按钮*/
.van-button--default .van-icon.van-icon-add {
  color: rgb(25, 137, 250);
}

.van-button--disabled .van-icon.van-icon-add {
  color: #c8c9cc;
}

/*套餐项目说明、自选项目说明*/
.van-cell__label {
  font-weight: normal;
  color: #aaa;
}

.grouplist-title {
  font-size: 2.2rem;
  margin-top: 1.4rem;
  margin-left: 1rem;
  margin-bottom: 1.4rem;
  position: relative;
  display: inline-block;
  padding-left: 1.8rem;
  color: #999;
}

.grouplist-title::before {
  content: '';
  position: absolute;
  bottom: .85rem;
  left: 0;
  width: 1rem;
  height: 1rem;
  background-image: linear-gradient(rgb(16, 227, 233), rgb(64, 158, 255));
  border-radius: 50%;
}
</style>
